{
  "AF": {
    "name": "Afghanistan",
    "provinces": {
      "BDS": "Badakhshan",
      "BDG": "Badghis",
      "BGL": "Baghlan",
      "BAL": "Balkh",
      "BAM": "Bamyan",
      "DAY": "Daykundi",
      "FRA": "Farah",
      "FYB": "Faryab",
      "GHA": "Ghazni",
      "GHO": "Ghor",
      "HEL": "Helmand",
      "HER": "Herat",
      "JOW": "Jowzjan",
      "KAB": "Kabul",
      "KAN": "Kandahar",
      "KAP": "Kapisa",
      "KHO": "Khost",
      "KNR": "Kunar",
      "KDZ": "Kunduz",
      "LAG": "Laghman",
      "LOG": "Logar",
      "NAN": "Nangarhar",
      "NIM": "Nimroz",
      "NUR": "Nuristan",
      "PKA": "Paktika",
      "PIA": "Paktiya",
      "PAN": "Panjshayr",
      "PAR": "Parwan",
      "SAM": "Samangan",
      "SAR": "Sar-e Pul",
      "TAK": "Takhar",
      "URU": "Uruzgan",
      "WAR": "Wardak",
      "ZAB": "Zabul"
    },
    "callingCodes": ["93"],
    "ISO2digit": "AF",
    "ISO3digit": "AFG",
    "allowed": false
  },
  "AX": {
    "name": "Aland Islands",
    "provinces": [
      "Brando",
      "Eckero",
      "Finstrom",
      "Foglo",
      "Geta",
      "Hammarland",
      "Jomala",
      "Kumlinge",
      "Kokar",
      "Lemland",
      "Lumparland",
      "Mariehamn",
      "Saltvik",
      "Sottunga",
      "Sund",
      "Vardo"
    ],
    "callingCodes": ["358"],
    "ISO2digit": "AX",
    "ISO3digit": "ALA",
    "allowed": false
  },
  "AL": {
    "name": "Albania",
    "provinces": {
      "01": "Berat",
      "09": "Diber",
      "02": "Durres",
      "03": "Elbasan",
      "04": "Fier",
      "05": "Gjirokaster",
      "06": "Korce",
      "07": "Kukes",
      "08": "Lezhe",
      "10": "Shkoder",
      "11": "Tirane",
      "12": "Vlore"
    },
    "callingCodes": ["355"],
    "ISO2digit": "AL",
    "ISO3digit": "ALB",
    "allowed": false
  },
  "DZ": {
    "name": "Algeria",
    "provinces": {
      "01": "Adrar",
      "44": "Ain Defla",
      "46": "Ain Temouchent",
      "16": "Alger",
      "23": "Annaba",
      "05": "Batna",
      "08": "Bechar",
      "06": "Bejaia",
      "07": "Biskra",
      "09": "Blida",
      "34": "Bordj Bou Arreridj",
      "10": "Bouira",
      "35": "Boumerdes",
      "02": "Chlef",
      "25": "Constantine",
      "17": "Djelfa",
      "32": "El Bayadh",
      "39": "El Oued",
      "36": "El Tarf",
      "47": "Ghardaia",
      "24": "Guelma",
      "33": "Illizi",
      "40": "Khenchela",
      "03": "Laghouat",
      "28": "M'sila",
      "29": "Mascara",
      "26": "Medea",
      "43": "Mila",
      "27": "Mostaganem",
      "45": "Naama",
      "31": "Oran",
      "30": "Ouargla",
      "04": "Oum el Bouaghi",
      "48": "Relizane",
      "20": "Saida",
      "19": "Setif",
      "22": "Sidi Bel Abbes",
      "21": "Skikda",
      "41": "Souk Ahras",
      "11": "Tamanrasset",
      "12": "Tebessa",
      "14": "Tiaret",
      "37": "Tindouf",
      "42": "Tipaza",
      "38": "Tissemsilt",
      "15": "Tizi Ouzou",
      "13": "Tlemcen"
    },
    "callingCodes": ["213"],
    "ISO2digit": "DZ",
    "ISO3digit": "DZA",
    "allowed": true
  },
  "AS": {
    "name": "American Samoa",
    "provinces": [
      "Eastern District",
      "Western District",
      "Manu'a District"
    ],
    "callingCodes": ["1684"],
    "ISO2digit": "AS",
    "ISO3digit": "ASM",
    "allowed": true
  },
  "AD": {
    "name": "Andorra",
    "provinces": {
      "07": "Andorra la Vella",
      "02": "Canillo",
      "03": "Encamp",
      "08": "Escaldes-Engordany",
      "04": "La Massana",
      "05": "Ordino",
      "06": "Sant Julia de Loria"
    },
    "callingCodes": ["376"],
    "ISO2digit": "AD",
    "ISO3digit": "AND",
    "allowed": true
  },
  "AO": {
    "name": "Angola",
    "provinces": {
      "BGO": "Bengo",
      "BGU": "Benguela",
      "BIE": "Bie",
      "CAB": "Cabinda",
      "CNN": "Cunene",
      "HUA": "Huambo",
      "HUI": "Huila",
      "CCU": "Kuando Kubango",
      "CNO": "Kwanza Norte",
      "CUS": "Kwanza Sul",
      "LUA": "Luanda",
      "LNO": "Lunda Norte",
      "LSU": "Lunda Sul",
      "MAL": "Malange",
      "MOX": "Moxico",
      "NAM": "Namibe",
      "UIG": "Uige",
      "ZAI": "Zaire"
    },
    "callingCodes": ["244"],
    "ISO2digit": "AO",
    "ISO3digit": "AGO",
    "allowed": true
  },
  "AI": {
    "name": "Anguilla",
    "provinces": [
      "Blowing Point",
      "East End",
      "George Hill",
      "Island Harbour",
      "North Hill",
      "North Side",
      "Sandy Ground",
      "Sandy Hill",
      "South Hill",
      "Stoney Ground",
      "The Farrington",
      "The Quarter",
      "The Valley",
      "West End"
    ],
    "callingCodes": ["1264"],
    "ISO2digit": "AI",
    "ISO3digit": "AIA",
    "allowed": true
  },
  "AQ": {
    "name": "Antarctica",
    "provinces": ["Antarctica"],
    "callingCodes": ["672"],
    "ISO2digit": "AQ",
    "ISO3digit": "ATA",
    "allowed": true
  },
  "AG": {
    "name": "Antigua and Barbuda",
    "provinces": {
      "10": "Barbuda",
      "11": "Redonda",
      "03": "Saint George",
      "04": "Saint John",
      "05": "Saint Mary",
      "06": "Saint Paul",
      "07": "Saint Peter",
      "08": "Saint Philip"
    },
    "callingCodes": ["1268"],
    "ISO2digit": "AG",
    "ISO3digit": "ATG",
    "allowed": true
  },
  "AR": {
    "name": "Argentina",
    "provinces": {
      "B": "Buenos Aires",
      "K": "Catamarca",
      "H": "Chaco",
      "U": "Chubut",
      "C": "Ciudad Autonoma de Buenos Aires",
      "X": "Cordoba",
      "W": "Corrientes",
      "E": "Entre Rios",
      "P": "Formosa",
      "Y": "Jujuy",
      "L": "La Pampa",
      "F": "La Rioja",
      "M": "Mendoza",
      "N": "Misiones",
      "Q": "Neuquen",
      "R": "Rio Negro",
      "A": "Salta",
      "J": "San Juan",
      "D": "San Luis",
      "Z": "Santa Cruz",
      "S": "Santa Fe",
      "G": "Santiago del Estero",
      "V": "Tierra del Fuego",
      "T": "Tucuman"
    },
    "callingCodes": ["54"],
    "ISO2digit": "AR",
    "ISO3digit": "ARG",
    "allowed": true
  },
  "AM": {
    "name": "Armenia",
    "provinces": {
      "AG": "Aragacotn",
      "AR": "Ararat",
      "AV": "Armavir",
      "ER": "Erevan",
      "GR": "Gegark'unik'",
      "KT": "Kotayk'",
      "LO": "Lori",
      "SH": "Sirak",
      "SU": "Syunik'",
      "TV": "Tavus",
      "VD": "Vayoc Jor"
    },
    "callingCodes": ["374"],
    "ISO2digit": "AM",
    "ISO3digit": "ARM",
    "allowed": false
  },
  "AW": {
    "name": "Aruba",
    "provinces": ["Aruba"],
    "callingCodes": ["297"],
    "ISO2digit": "AW",
    "ISO3digit": "ABW",
    "allowed": true
  },
  "AU": {
    "name": "Australia",
    "provinces": {
      "ACT": "Australian Capital Territory",
      "NSW": "New South Wales",
      "NT": "Northern Territory",
      "QLD": "Queensland",
      "SA": "South Australia",
      "TAS": "Tasmania",
      "VIC": "Victoria",
      "WA": "Western Australia"
    },
    "callingCodes": ["61"],
    "ISO2digit": "AU",
    "ISO3digit": "AUS",
    "allowed": false
  },
  "AT": {
    "name": "Austria",
    "provinces": {
      "1": "Burgenland",
      "2": "Karnten",
      "3": "Niederosterreich",
      "4": "Oberosterreich",
      "5": "Salzburg",
      "6": "Steiermark",
      "7": "Tirol",
      "8": "Vorarlberg",
      "9": "Wien"
    },
    "callingCodes": ["43"],
    "ISO2digit": "AT",
    "ISO3digit": "AUT",
    "allowed": true
  },
  "AZ": {
    "name": "Azerbaijan",
    "provinces": {
      "ABS": "Absheron",
      "AGM": "Agdam",
      "AGS": "Agdash",
      "AGC": "Aghjabadi",
      "AGA": "Agstafa",
      "AGU": "Agsu",
      "AST": "Astara",
      "BAB": "Babek",
      "BA": "Baku",
      "BAL": "Balakan",
      "BAR": "Barda",
      "BEY": "Beylagan",
      "BIL": "Bilasuvar",
      "DAS": "Dashkasan",
      "FUZ": "Fuzuli",
      "GAD": "Gadabay",
      "GA": "Ganja",
      "QOB": "Gobustan",
      "GOR": "Goranboy",
      "GOY": "Goychay",
      "GYG": "Goygol",
      "HAC": "Hajigabul",
      "IMI": "Imishli",
      "ISM": "Ismailli",
      "CAB": "Jabrayil",
      "CAL": "Jalilabad",
      "CUL": "Julfa",
      "KAL": "Kalbajar",
      "KAN": "Kangarli",
      "XAC": "Khachmaz",
      "XIZ": "Khizi",
      "XCI": "Khojaly",
      "XVD": "Khojavend",
      "KUR": "Kurdamir",
      "LAC": "Lachin",
      "LA": "Lankaran",
      "LAN": "Lankaran",
      "LER": "Lerik",
      "MAS": "Masally",
      "MI": "Mingachevir",
      "NA": "Naftalan",
      "NV": "Nakhchivan",
      "NEF": "Neftchala",
      "OGU": "Oghuz",
      "ORD": "Ordubad",
      "QAX": "Qakh",
      "QAZ": "Qazakh",
      "QAB": "Qbala",
      "QBA": "Quba",
      "QBI": "Qubadli",
      "QUS": "Qusar",
      "SAT": "Saatly",
      "SAB": "Sabirabad",
      "SAD": "Sadarak",
      "SAL": "Salyan",
      "SMX": "Samukh",
      "SBN": "Shabran",
      "SAH": "Shahbuz",
      "SA": "Shaki",
      "SAK": "Shaki",
      "SMI": "Shamakhi",
      "SKR": "Shamkir",
      "SAR": "Sharur",
      "SR": "Shirvan",
      "SUS": "Shusha",
      "SIY": "Siazan",
      "XA": "Stepanakert",
      "SM": "Sumqayit",
      "TAR": "Tartar",
      "TOV": "Tovuz",
      "UCA": "Ujar",
      "YAR": "Yardymli",
      "YE": "Yevlakh",
      "YEV": "Yevlakh",
      "ZAN": "Zangilan",
      "ZAQ": "Zaqatala",
      "ZAR": "Zardab"
    },
    "callingCodes": ["994"],
    "ISO2digit": "AZ",
    "ISO3digit": "AZE",
    "allowed": true
  },
  "BS": {
    "name": "Bahamas",
    "provinces": {
      "AK": "Acklins",
      "BY": "Berry Islands",
      "BI": "Bimini",
      "BP": "Black Point",
      "CI": "Cat Island",
      "CO": "Central Abaco",
      "CS": "Central Andros",
      "CE": "Central Eleuthera",
      "FP": "City of Freeport",
      "CK": "Crooked Island and Long Cay",
      "EG": "East Grand Bahama",
      "EX": "Exuma",
      "GC": "Grand Cay",
      "HI": "Harbour Island",
      "HT": "Hope Town",
      "IN": "Inagua",
      "LI": "Long Island",
      "MC": "Mangrove Cay",
      "MG": "Mayaguana",
      "MI": "Moores Island",
      "NO": "North Abaco",
      "NS": "North Andros",
      "NE": "North Eleuthera",
      "RI": "Ragged Island",
      "RC": "Rum Cay",
      "SS": "San Salvador",
      "SO": "South Abaco",
      "SA": "South Andros",
      "SE": "South Eleuthera",
      "SW": "Spanish Wells",
      "WG": "West Grand Bahama"
    },
    "callingCodes": ["1242"],
    "ISO2digit": "BS",
    "ISO3digit": "BHS",
    "allowed": true
  },
  "BH": {
    "name": "Bahrain",
    "provinces": {
      "13": "Al 'Asimah",
      "14": "Al Janubiyah",
      "15": "Al Muharraq",
      "17": "Ash Shamaliyah"
    },
    "callingCodes": ["973"],
    "ISO2digit": "BH",
    "ISO3digit": "BHR",
    "allowed": true
  },
  "BD": {
    "name": "Bangladesh",
    "provinces": {
      "A": "Barisal",
      "B": "Chittagong",
      "C": "Dhaka",
      "D": "Khulna",
      "H": "Mymensingh",
      "E": "Rajshahi",
      "F": "Rangpur",
      "G": "Sylhet"
    },
    "callingCodes": ["880"],
    "ISO2digit": "BD",
    "ISO3digit": "BGD",
    "allowed": true
  },
  "BB": {
    "name": "Barbados",
    "provinces": {
      "01": "Christ Church",
      "02": "Saint Andrew",
      "03": "Saint George",
      "04": "Saint James",
      "05": "Saint John",
      "06": "Saint Joseph",
      "07": "Saint Lucy",
      "08": "Saint Michael",
      "09": "Saint Peter",
      "10": "Saint Philip",
      "11": "Saint Thomas"
    },
    "callingCodes": ["1246"],
    "ISO2digit": "BB",
    "ISO3digit": "BRB",
    "allowed": true
  },
  "BY": {
    "name": "Belarus",
    "provinces": {
      "BR": "Brestskaya voblasts'",
      "HO": "Homyel'skaya voblasts'",
      "HR": "Hrodzenskaya voblasts'",
      "MA": "Mahilyowskaya voblasts'",
      "MI": "Minskaya voblasts'",
      "VI": "Vitsyebskaya voblasts'",
      "HM": "Horad Minsk"
    },
    "callingCodes": ["375"],
    "ISO2digit": "BY",
    "ISO3digit": "BLR",
    "allowed": false
  },
  "BE": {
    "name": "Belgium",
    "provinces": {
      "BRU": "Brussels Hoofdstedelijk Gewest",
      "VAN": "Antwerpen",
      "WBR": "Brabant wallon",
      "WHT": "Hainaut",
      "WLG": "Liege",
      "VLI": "Limburg",
      "WLX": "Luxembourg",
      "WNA": "Namur",
      "VOV": "Oost-Vlaanderen",
      "VBR": "Vlaams-Brabant",
      "VWV": "West-Vlaanderen"
    },
    "callingCodes": ["32"],
    "ISO2digit": "BE",
    "ISO3digit": "BEL",
    "allowed": true
  },
  "BZ": {
    "name": "Belize",
    "provinces": {
      "BZ": "Belize",
      "CY": "Cayo",
      "CZL": "Corozal",
      "OW": "Orange Walk",
      "SC": "Stann Creek",
      "TOL": "Toledo"
    },
    "callingCodes": ["501"],
    "ISO2digit": "BZ",
    "ISO3digit": "BLZ",
    "allowed": true
  },
  "BJ": {
    "name": "Benin",
    "provinces": {
      "AL": "Alibori",
      "AK": "Atacora",
      "AQ": "Atlantique",
      "BO": "Borgou",
      "CO": "Collines",
      "KO": "Couffo",
      "DO": "Donga",
      "LI": "Littoral",
      "MO": "Mono",
      "OU": "Oueme",
      "PL": "Plateau",
      "ZO": "Zou"
    },
    "callingCodes": ["229"],
    "ISO2digit": "BJ",
    "ISO3digit": "BEN",
    "allowed": true
  },
  "BM": {
    "name": "Bermuda",
    "provinces": [
      "Devonshire",
      "Hamilton",
      "Paget",
      "Pembroke",
      "Sandys",
      "Smith's",
      "Southampton",
      "St George's",
      "Warwick"
    ],
    "callingCodes": ["1441"],
    "ISO2digit": "BM",
    "ISO3digit": "BMU",
    "allowed": true
  },
  "BT": {
    "name": "Bhutan",
    "provinces": {
      "33": "Bumthang",
      "12": "Chhukha",
      "22": "Dagana",
      "GA": "Gasa",
      "13": "Ha",
      "44": "Lhuentse",
      "42": "Monggar",
      "11": "Paro",
      "43": "Pemagatshel",
      "23": "Punakha",
      "45": "Samdrup",
      "14": "Samtse",
      "31": "Sarpang",
      "15": "Thimphu",
      "41": "Trashigang",
      "TY": "Trashi Yangtse",
      "32": "Trongsa",
      "21": "Tsirang",
      "24": "Wangdue Phodrang",
      "34": "Zhemgang"
    },
    "callingCodes": ["975"],
    "ISO2digit": "BT",
    "ISO3digit": "BTN",
    "allowed": true
  },
  "BO": {
    "name": "Bolivia",
    "provinces": {
      "H": "Chuquisaca",
      "C": "Cochabamba",
      "B": "El Beni",
      "L": "La Paz",
      "O": "Oruro",
      "N": "Pando",
      "P": "Potosi",
      "S": "Santa Cruz",
      "T": "Tarija"
    },
    "callingCodes": ["591"],
    "ISO2digit": "BO",
    "ISO3digit": "BOL",
    "allowed": true
  },
  "BQ": {
    "name": "Bonaire",
    "provinces": {
      "BO": "Bonaire",
      "SA": "Saba",
      "SE": "Sint Eustatius"
    },
    "callingCodes": ["5997"],
    "ISO2digit": "BQ",
    "ISO3digit": "BES",
    "allowed": true
  },
  "BA": {
    "name": "Bosnia and Herzegovina",
    "provinces": {
      "BIH": "Federacija Bosna i Hercegovina",
      "SRP": "Republika Srpska",
      "BRC": "Brcko distrikt"
    },
    "callingCodes": ["387"],
    "ISO2digit": "BA",
    "ISO3digit": "BIH",
    "allowed": false
  },
  "BW": {
    "name": "Botswana",
    "provinces": {
      "CE": "Central",
      "CH": "Chobe",
      "FR": "Francistown",
      "GA": "Gaborone",
      "GH": "Ghanzi",
      "JW": "Jwaneng",
      "KG": "Kgalagadi",
      "KL": "Kgatleng",
      "KW": "Kweneng",
      "LO": "Lobatse",
      "NE": "North East",
      "NW": "North West",
      "SP": "Selibe Phikwe",
      "SE": "South East",
      "SO": "Southern",
      "ST": "Sowa Town"
    },
    "callingCodes": ["267"],
    "ISO2digit": "BW",
    "ISO3digit": "BWA",
    "allowed": true
  },
  "BV": {
    "name": "Bouvet Island",
    "provinces": ["Bouvet Island"],
    "callingCodes": ["47"],
    "ISO2digit": "BV",
    "ISO3digit": "BVT",
    "allowed": true
  },
  "BR": {
    "name": "Brazil",
    "provinces": {
      "DF": "Distrito Federal",
      "AC": "Acre",
      "AL": "Alagoas",
      "AP": "Amapa",
      "AM": "Amazonas",
      "BA": "Bahia",
      "CE": "Ceara",
      "ES": "Espirito Santo",
      "GO": "Goias",
      "MA": "Maranhao",
      "MT": "Mato Grosso",
      "MS": "Mato Grosso do Sul",
      "MG": "Minas Gerais",
      "PA": "Para",
      "PB": "Paraiba",
      "PR": "Parana",
      "PE": "Pernambuco",
      "PI": "Piaui",
      "RJ": "Rio de Janeiro",
      "RN": "Rio Grande do Norte",
      "RS": "Rio Grande do Sul",
      "RO": "Rondonia",
      "RR": "Roraima",
      "SC": "Santa Catarina",
      "SP": "Sao Paulo",
      "SE": "Sergipe",
      "TO": "Tocantins"
    },
    "callingCodes": ["55"],
    "ISO2digit": "BR",
    "ISO3digit": "BRA",
    "allowed": true
  },
  "IO": {
    "name": "British Indian Ocean Territory",
    "provinces": ["British Indian Ocean Territory"],
    "callingCodes": ["246"],
    "ISO2digit": "IO",
    "ISO3digit": "IOT",
    "allowed": true
  },
  "BN": {
    "name": "Brunei Darussalam",
    "provinces": {
      "BE": "Belait",
      "BM": "Brunei-Muara",
      "TE": "Temburong",
      "TU": "Tutong"
    },
    "callingCodes": ["673"],
    "ISO2digit": "BN",
    "ISO3digit": "BRN",
    "allowed": true
  },
  "BG": {
    "name": "Bulgaria",
    "provinces": {
      "01": "Blagoevgrad",
      "02": "Burgas",
      "08": "Dobrich",
      "07": "Gabrovo",
      "26": "Haskovo",
      "09": "Kardzhali",
      "10": "Kyustendil",
      "11": "Lovech",
      "12": "Montana",
      "13": "Pazardzhik",
      "14": "Pernik",
      "15": "Pleven",
      "16": "Plovdiv",
      "17": "Razgrad",
      "18": "Ruse",
      "27": "Shumen",
      "19": "Silistra",
      "20": "Sliven",
      "21": "Smolyan",
      "23": "Sofia",
      "22": "Sofia (stolitsa)",
      "24": "Stara Zagora",
      "25": "Targovishte",
      "03": "Varna",
      "04": "Veliko Tarnovo",
      "05": "Vidin",
      "06": "Vratsa",
      "28": "Yambol"
    },
    "callingCodes": ["359"],
    "ISO2digit": "BG",
    "ISO3digit": "BGR",
    "allowed": false
  },
  "BF": {
    "name": "Burkina Faso",
    "provinces": {
      "BAL": "Bale",
      "BAM": "Bam",
      "BAN": "Banwa",
      "BAZ": "Bazega",
      "BGR": "Bougouriba",
      "BLG": "Boulgou",
      "BLK": "Boulkiemde",
      "COM": "Comoe",
      "GAN": "Ganzourgou",
      "GNA": "Gnagna",
      "GOU": "Gourma",
      "HOU": "Houet",
      "IOB": "Ioba",
      "KAD": "Kadiogo",
      "KEN": "Kenedougou",
      "KMD": "Komondjari",
      "KMP": "Kompienga",
      "KOS": "Kossi",
      "KOP": "Koulpelogo",
      "KOT": "Kouritenga",
      "KOW": "Kourweogo",
      "LER": "Leraba",
      "LOR": "Loroum",
      "MOU": "Mouhoun",
      "NAO": "Nahouri",
      "NAM": "Namentenga",
      "NAY": "Nayala",
      "NOU": "Noumbiel",
      "OUB": "Oubritenga",
      "OUD": "Oudalan",
      "PAS": "Passore",
      "PON": "Poni",
      "SNG": "Sanguie",
      "SMT": "Sanmatenga",
      "SEN": "Seno",
      "SIS": "Sissili",
      "SOM": "Soum",
      "SOR": "Sourou",
      "TAP": "Tapoa",
      "TUI": "Tuy",
      "YAG": "Yagha",
      "YAT": "Yatenga",
      "ZIR": "Ziro",
      "ZON": "Zondoma",
      "ZOU": "Zoundweogo"
    },
    "callingCodes": ["226"],
    "ISO2digit": "BF",
    "ISO3digit": "BFA",
    "allowed": true
  },
  "BI": {
    "name": "Burundi",
    "provinces": {
      "BB": "Bubanza",
      "BM": "Bujumbura Mairie",
      "BL": "Bujumbura Rural",
      "BR": "Bururi",
      "CA": "Cankuzo",
      "CI": "Cibitoke",
      "GI": "Gitega",
      "KR": "Karuzi",
      "KY": "Kayanza",
      "KI": "Kirundo",
      "MA": "Makamba",
      "MU": "Muramvya",
      "MY": "Muyinga",
      "MW": "Mwaro",
      "NG": "Ngozi",
      "RM": "Rumonge",
      "RT": "Rutana",
      "RY": "Ruyigi"
    },
    "callingCodes": ["257"],
    "ISO2digit": "BI",
    "ISO3digit": "BDI",
    "allowed": true
  },
  "KH": {
    "name": "Cambodia",
    "provinces": {
      "12": "Phnom Penh",
      "2": "Baat Dambang",
      "1": "Banteay Mean Chey",
      "3": "Kampong Chaam",
      "4": "Kampong Chhnang",
      "5": "Kampong Spueu",
      "6": "Kampong Thum",
      "7": "Kampot",
      "8": "Kandaal",
      "9": "Kaoh Kong",
      "10": "Kracheh",
      "23": "Krong Kaeb",
      "24": "Krong Pailin",
      "18": "Krong Preah Sihanouk",
      "11": "Mondol Kiri",
      "22": "Otdar Mean Chey",
      "15": "Pousaat",
      "13": "Preah Vihear",
      "14": "Prey Veaeng",
      "16": "Rotanak Kiri",
      "17": "Siem Reab",
      "19": "Stueng Traeng",
      "20": "Svaay Rieng",
      "21": "Taakaev",
      "25": "Tbong Khmum"
    },
    "callingCodes": ["855"],
    "ISO2digit": "KH",
    "ISO3digit": "KHM",
    "allowed": true
  },
  "CM": {
    "name": "Cameroon",
    "provinces": {
      "AD": "Adamaoua",
      "CE": "Centre",
      "ES": "Est",
      "EN": "Extreme-Nord",
      "LT": "Littoral",
      "NO": "Nord",
      "NW": "Nord-Ouest",
      "OU": "Ouest",
      "SU": "Sud",
      "SW": "Sud-Ouest"
    },
    "callingCodes": ["237"],
    "ISO2digit": "CM",
    "ISO3digit": "CMR",
    "allowed": true
  },
  "CA": {
    "name": "Canada",
    "provinces": {
      "AB": "Alberta",
      "BC": "British Columbia",
      "MB": "Manitoba",
      "NB": "New Brunswick",
      "NL": "Newfoundland and Labrador",
      "NT": "Northwest Territories",
      "NS": "Nova Scotia",
      "NU": "Nunavut",
      "ON": "Ontario",
      "PE": "Prince Edward Island",
      "QC": "Quebec",
      "SK": "Saskatchewan",
      "YT": "Yukon"
    },
    "callingCodes": ["1"],
    "ISO2digit": "CA",
    "ISO3digit": "CAN",
    "allowed": true
  },
  "CV": {
    "name": "Cape Verde",
    "provinces": {
      "BV": "Boa Vista",
      "BR": "Brava",
      "MA": "Maio",
      "MO": "Mosteiros",
      "PA": "Paul",
      "PN": "Porto Novo",
      "PR": "Praia",
      "RB": "Ribeira Brava",
      "RG": "Ribeira Grande",
      "RS": "Ribeira Grande de Santiago",
      "SL": "Sal",
      "CA": "Santa Catarina",
      "CF": "Santa Catarina do Fogo",
      "CR": "Santa Cruz",
      "SD": "Sao Domingos",
      "SF": "Sao Filipe",
      "SM": "Sao Miguel",
      "SS": "Sao Salvador do Mundo",
      "SV": "Sao Vicente",
      "TA": "Tarrafal",
      "TS": "Tarrafal de Sao Nicolau"
    },
    "callingCodes": ["238"],
    "ISO2digit": "CV",
    "ISO3digit": "CPV",
    "allowed": true
  },
  "KY": {
    "name": "Cayman Islands",
    "provinces": [
      "Bodden Town",
      "Cayman Brac",
      "East End",
      "George Town",
      "Little Cayman",
      "North Side",
      "West Bay"
    ],
    "callingCodes": ["1345"],
    "ISO2digit": "KY",
    "ISO3digit": "CYM",
    "allowed": true
  },
  "CF": {
    "name": "Central African Republic",
    "provinces": {
      "BB": "Bamingui-Bangoran",
      "BGF": "Bangui",
      "BK": "Basse-Kotto",
      "KB": "Gribingui",
      "HM": "Haut-Mbomou",
      "HK": "Haute-Kotto",
      "KG": "Kemo-Gribingui",
      "LB": "Lobaye",
      "HS": "Mambere-Kadei",
      "MB": "Mbomou",
      "NM": "Nana-Mambere",
      "MP": "Ombella-Mpoko",
      "UK": "Ouaka",
      "AC": "Ouham",
      "OP": "Ouham-Pende",
      "SE": "Sangha"
    },
    "callingCodes": ["236"],
    "ISO2digit": "CF",
    "ISO3digit": "CAF",
    "allowed": true
  },
  "TD": {
    "name": "Chad",
    "provinces": {
      "BG": "Bahr el Gazel",
      "BA": "Batha",
      "BO": "Borkou",
      "CB": "Chari-Baguirmi",
      "EE": "Ennedi-Est",
      "EO": "Ennedi-Ouest",
      "GR": "Guera",
      "HL": "Hadjer Lamis",
      "KA": "Kanem",
      "LC": "Lac",
      "LO": "Logone-Occidental",
      "LR": "Logone-Oriental",
      "MA": "Mandoul",
      "ME": "Mayo-Kebbi-Est",
      "MO": "Mayo-Kebbi-Ouest",
      "MC": "Moyen-Chari",
      "OD": "Ouaddai",
      "SA": "Salamat",
      "SI": "Sila",
      "TA": "Tandjile",
      "TI": "Tibesti",
      "ND": "Ville de Ndjamena",
      "WF": "Wadi Fira"
    },
    "callingCodes": ["235"],
    "ISO2digit": "TD",
    "ISO3digit": "TCD",
    "allowed": true
  },
  "CL": {
    "name": "Chile",
    "provinces": {
      "AI": "Aisen del General Carlos Ibanez del Campo",
      "AN": "Antofagasta",
      "AP": "Arica y Parinacota",
      "AT": "Atacama",
      "BI": "Biobio",
      "CO": "Coquimbo",
      "AR": "La Araucania",
      "LI": "Libertador General Bernardo O'Higgins",
      "LL": "Los Lagos",
      "LR": "Los Rios",
      "MA": "Magallanes",
      "ML": "Maule",
      "RM": "Region Metropolitana de Santiago",
      "TA": "Tarapaca",
      "VS": "Valparaiso"
    },
    "callingCodes": ["56"],
    "ISO2digit": "CL",
    "ISO3digit": "CHL",
    "allowed": true
  },
  "CN": {
    "name": "China",
    "provinces": {
      "34": "Anhui",
      "11": "Beijing",
      "50": "Chongqing",
      "35": "Fujian",
      "62": "Gansu",
      "44": "Guangdong",
      "45": "Guangxi",
      "52": "Guizhou",
      "46": "Hainan",
      "13": "Hebei",
      "23": "Heilongjiang",
      "41": "Henan",
      "91": "Hong Kong",
      "42": "Hubei",
      "43": "Hunan",
      "32": "Jiangsu",
      "36": "Jiangxi",
      "22": "Jilin",
      "21": "Liaoning",
      "92": "Macao",
      "15": "Nei Mongol",
      "64": "Ningxia",
      "63": "Qinghai",
      "61": "Shaanxi",
      "37": "Shandong",
      "31": "Shanghai",
      "14": "Shanxi",
      "51": "Sichuan",
      "71": "Taiwan",
      "12": "Tianjin",
      "65": "Xinjiang",
      "54": "Xizang",
      "53": "Yunnan",
      "33": "Zhejiang"
    },
    "callingCodes": ["86"],
    "ISO2digit": "CN",
    "ISO3digit": "CHN",
    "allowed": true
  },
  "CX": {
    "name": "Christmas Island",
    "provinces": ["Christmas Island"],
    "callingCodes": ["61"],
    "ISO2digit": "CX",
    "ISO3digit": "CXR",
    "allowed": true
  },
  "CC": {
    "name": "Cocos (Keeling) Islands",
    "provinces": ["Cocos (Keeling) Islands"],
    "callingCodes": ["61"],
    "ISO2digit": "CC",
    "ISO3digit": "CCK",
    "allowed": true
  },
  "CO": {
    "name": "Colombia",
    "provinces": {
      "AMA": "Amazonas",
      "ANT": "Antioquia",
      "ARA": "Arauca",
      "ATL": "Atlantico",
      "BOL": "Bolivar",
      "BOY": "Boyaca",
      "CAL": "Caldas",
      "CAQ": "Caqueta",
      "CAS": "Casanare",
      "CAU": "Cauca",
      "CES": "Cesar",
      "CHO": "Choco",
      "COR": "Cordoba",
      "CUN": "Cundinamarca",
      "DC": "Distrito Capital de Bogota",
      "GUA": "Guainia",
      "GUV": "Guaviare",
      "HUI": "Huila",
      "LAG": "La Guajira",
      "MAG": "Magdalena",
      "MET": "Meta",
      "NAR": "Narino",
      "NSA": "Norte de Santander",
      "PUT": "Putumayo",
      "QUI": "Quindio",
      "RIS": "Risaralda",
      "SAP": "San Andres, Providencia y Santa Catalina",
      "SAN": "Santander",
      "SUC": "Sucre",
      "TOL": "Tolima",
      "VAC": "Valle del Cauca",
      "VAU": "Vaupes",
      "VID": "Vichada"
    },
    "callingCodes": ["57"],
    "ISO2digit": "CO",
    "ISO3digit": "COL",
    "allowed": true
  },
  "KM": {
    "name": "Comoros",
    "provinces": {
      "A": "Anjouan",
      "G": "Grande Comore",
      "M": "Moheli"
    },
    "callingCodes": ["269"],
    "ISO2digit": "KM",
    "ISO3digit": "COM",
    "allowed": true
  },
  "CG": {
    "name": "Congo, Republic of",
    "provinces": {
      "11": "Bouenza",
      "BZV": "Brazzaville",
      "8": "Cuvette",
      "15": "Cuvette-Ouest",
      "2": "Lekoumou",
      "7": "Likouala",
      "9": "Niari",
      "14": "Plateaux",
      "16": "Pointe-Noire",
      "12": "Pool",
      "13": "Sangha"
    },
    "callingCodes": ["242"],
    "ISO2digit": "CG",
    "ISO3digit": "COG",
    "allowed": true
  },
  "CD": {
    "name": "Congo, Democratic Republic of",
    "provinces": {
      "BU": "Bas-Uele",
      "EQ": "Equateur",
      "HK": "Haut-Katanga",
      "HL": "Haut-Lomani",
      "HU": "Haut-Uele",
      "IT": "Ituri",
      "KS": "Kasai",
      "KC": "Kasai Central",
      "KE": "Kasai Oriental",
      "KN": "Kinshasa",
      "BC": "Kongo Central",
      "KG": "Kwango",
      "KL": "Kwilu",
      "LO": "Lomami",
      "LU": "Lualaba",
      "MN": "Mai-Ndombe",
      "MA": "Maniema",
      "MO": "Mongala",
      "NK": "Nord-Kivu",
      "NU": "Nord-Ubangi",
      "SA": "Sankuru",
      "SK": "Sud-Kivu",
      "SU": "Sud-Ubangi",
      "TA": "Tanganyika",
      "TO": "Tshopo",
      "TU": "Tshuapa"
    },
    "callingCodes": ["243"],
    "ISO2digit": "CD",
    "ISO3digit": "COD",
    "allowed": true
  },
  "CK": {
    "name": "Cook Islands",
    "provinces": ["Cook Islands"],
    "callingCodes": ["682"],
    "ISO2digit": "CK",
    "ISO3digit": "COK",
    "allowed": true
  },
  "CR": {
    "name": "Costa Rica",
    "provinces": {
      "A": "Alajuela",
      "C": "Cartago",
      "G": "Guanacaste",
      "H": "Heredia",
      "L": "Limon",
      "P": "Puntarenas",
      "SJ": "San Jose"
    },
    "callingCodes": ["506"],
    "ISO2digit": "CR",
    "ISO3digit": "CRI",
    "allowed": false
  },
  "CI": {
    "name": "Cote d'Ivoire",
    "provinces": {
      "AB": "Abidjan",
      "BS": "Bas-Sassandra",
      "CM": "Comoe",
      "DN": "Denguele",
      "GD": "Goh-Djiboua",
      "LC": "Lacs",
      "LG": "Lagunes",
      "MG": "Montagnes",
      "SM": "Sassandra-Marahoue",
      "SV": "Savanes",
      "VB": "Vallee du Bandama",
      "WR": "Woroba",
      "YM": "Yamoussoukro",
      "ZZ": "Zanzan"
    },
    "callingCodes": ["225"],
    "ISO2digit": "CI",
    "ISO3digit": "CIV",
    "allowed": true
  },
  "HR": {
    "name": "Croatia",
    "provinces": {
      "07": "Bjelovarsko-bilogorska zupanija",
      "12": "Brodsko-posavska zupanija",
      "19": "Dubrovacko-neretvanska zupanija",
      "21": "Grad Zagreb",
      "18": "Istarska zupanija",
      "04": "Karlovacka zupanija",
      "06": "Koprivnicko-krizevacka zupanija",
      "02": "Krapinsko-zagorska zupanija",
      "09": "Licko-senjska zupanija",
      "20": "Medimurska zupanija",
      "14": "Osjecko-baranjska zupanija",
      "11": "Pozesko-slavonska zupanija",
      "08": "Primorsko-goranska zupanija",
      "15": "Sibensko-kninska zupanija",
      "03": "Sisacko-moslavacka zupanija",
      "17": "Splitsko-dalmatinska zupanija",
      "05": "Varazdinska zupanija",
      "10": "Viroviticko-podravska zupanija",
      "16": "Vukovarsko-srijemska zupanija",
      "13": "Zadarska zupanija",
      "01": "Zagrebacka zupanija"
    },
    "callingCodes": ["385"],
    "ISO2digit": "HR",
    "ISO3digit": "HRV",
    "allowed": true
  },
  "CU": {
    "name": "Cuba",
    "provinces": {
      "15": "Artemisa",
      "09": "Camaguey",
      "08": "Ciego de Avila",
      "06": "Cienfuegos",
      "12": "Granma",
      "14": "Guantanamo",
      "11": "Holguin",
      "99": "Isla de la Juventud",
      "03": "La Habana",
      "10": "Las Tunas",
      "04": "Matanzas",
      "16": "Mayabeque",
      "01": "Pinar del Rio",
      "07": "Sancti Spiritus",
      "13": "Santiago de Cuba",
      "05": "Villa Clara"
    },
    "callingCodes": ["53"],
    "ISO2digit": "CU",
    "ISO3digit": "CUB",
    "allowed": true
  },
  "CW": {
    "name": "Curacao",
    "provinces": ["Curacao"],
    "callingCodes": ["5999"],
    "ISO2digit": "CW",
    "ISO3digit": "CUW",
    "allowed": true
  },
  "CY": {
    "name": "Cyprus",
    "provinces": {
      "04": "Ammochostos",
      "06": "Keryneia",
      "03": "Larnaka",
      "01": "Lefkosia",
      "02": "Lemesos",
      "05": "Pafos"
    },
    "callingCodes": ["357"],
    "ISO2digit": "CY",
    "ISO3digit": "CYP",
    "allowed": true
  },
  "CZ": {
    "name": "Czech Republic",
    "provinces": {
      "31": "Jihoceský kraj",
      "64": "Jihomoravský kraj",
      "41": "Karlovarský kraj",
      "52": "Královéhradecký kraj",
      "51": "Liberecký kraj",
      "80": "Moravskoslezský kraj",
      "71": "Olomoucký kraj",
      "53": "Pardubický kraj",
      "32": "Plzenský kraj",
      "10": "Praha, hlavní mesto",
      "20": "Stredoceský kraj",
      "42": "Ústecký kraj",
      "63": "Vysocina",
      "72": "Zlínský kraj"
    },
    "callingCodes": ["420"],
    "ISO2digit": "CZ",
    "ISO3digit": "CZE",
    "allowed": true
  },
  "DK": {
    "name": "Denmark",
    "provinces": {
      "84": "Hovedstaden",
      "82": "Midtjylland",
      "81": "Nordjylland",
      "85": "Sjelland",
      "83": "Syddanmark"
    },
    "callingCodes": ["45"],
    "ISO2digit": "DK",
    "ISO3digit": "DNK",
    "allowed": true
  },
  "DJ": {
    "name": "Djibouti",
    "provinces": {
      "AS": "Ali Sabieh",
      "AR": "Arta",
      "DI": "Dikhil",
      "DJ": "Djibouti",
      "OB": "Obock",
      "TA": "Tadjourah"
    },
    "callingCodes": ["253"],
    "ISO2digit": "DJ",
    "ISO3digit": "DJI",
    "allowed": true
  },
  "DM": {
    "name": "Dominica",
    "provinces": {
      "2": "Saint Andrew",
      "3": "Saint David",
      "4": "Saint George",
      "5": "Saint John",
      "6": "Saint Joseph",
      "7": "Saint Luke",
      "8": "Saint Mark",
      "9": "Saint Patrick",
      "10": "Saint Paul",
      "11": "Saint Peter"
    },
    "callingCodes": ["1767"],
    "ISO2digit": "DM",
    "ISO3digit": "DMA",
    "allowed": true
  },
  "DO": {
    "name": "Dominican Republic",
    "provinces": {
      "1": "Distrito Nacional (Santo Domingo)",
      "2": "Azua",
      "3": "Baoruco",
      "4": "Barahona",
      "5": "Dajabón",
      "6": "Duarte",
      "8": "El Seibo",
      "9": "Espaillat",
      "30": "Hato Mayor",
      "10": "Independencia",
      "11": "La Altagracia",
      "7": "Elías Piña",
      "12": "La Romana",
      "13": "La Vega",
      "14": "María Trinidad Sánchez",
      "28": "Monseñor Nouel",
      "15": "Monte Cristi",
      "29": "Monte Plata",
      "16": "Pedernales",
      "17": "Peravia",
      "18": "Puerto Plata",
      "19": "Hermanas Mirabal",
      "20": "Samaná",
      "21": "San Cristóbal",
      "31": "San José de Ocoa",
      "22": "San Juan",
      "23": "San Pedro de Macorís",
      "24": "Sánchez Ramírez",
      "25": "Santiago",
      "26": "Santiago Rodríguez",
      "32": "Santo Domingo",
      "27": "Valverde"
    },
    "callingCodes": ["1809", "1829", "1849"],
    "ISO2digit": "DO",
    "ISO3digit": "DOM",
    "allowed": true
  },
  "EC": {
    "name": "Ecuador",
    "provinces": {
      "A": "Azuay",
      "B": "Bolivar",
      "F": "Canar",
      "C": "Carchi",
      "H": "Chimborazo",
      "X": "Cotopaxi",
      "O": "El Oro",
      "E": "Esmeraldas",
      "W": "Galapagos",
      "G": "Guayas",
      "I": "Imbabura",
      "L": "Loja",
      "R": "Los Rios",
      "M": "Manabi",
      "S": "Morona-Santiago",
      "N": "Napo",
      "D": "Orellana",
      "Y": "Pastaza",
      "P": "Pichincha",
      "SE": "Santa Elena",
      "U": "Sucumbios",
      "T": "Tungurahua",
      "Z": "Zamora-Chinchipe"
    },
    "callingCodes": ["593"],
    "ISO2digit": "EC",
    "ISO3digit": "ECU",
    "allowed": true
  },
  "EG": {
    "name": "Egypt",
    "provinces": {
      "DK": "Ad Daqahliyah",
      "BA": "Al Bahr al Ahmar",
      "BH": "Al Buhayrah",
      "FYM": "Al Fayyum",
      "GH": "Al Gharbiyah",
      "ALX": "Al Iskandariyah",
      "IS": "Al Isma'iliyah",
      "GZ": "Al Jizah",
      "MNF": "Al Minufiyah",
      "MN": "Al Minya",
      "C": "Al Qahirah",
      "KB": "Al Qalyubiyah",
      "LX": "Al Uqsur",
      "WAD": "Al Wadi al Jadid",
      "SUZ": "As Suways",
      "SHR": "Ash Sharqiyah",
      "ASN": "Aswan",
      "AST": "Asyut",
      "BNS": "Bani Suwayf",
      "PTS": "Bur Sa'id",
      "DT": "Dumyat",
      "JS": "Janub Sina'",
      "KFS": "Kafr ash Shaykh",
      "MT": "Matruh",
      "KN": "Qina",
      "SIN": "Shamal Sina'",
      "SHG": "Suhaj"
    },
    "callingCodes": ["20"],
    "ISO2digit": "EG",
    "ISO3digit": "EGY",
    "allowed": true
  },
  "SV": {
    "name": "El Salvador",
    "provinces": {
      "AH": "Ahuachapan",
      "CA": "Cabanas",
      "CH": "Chalatenango",
      "CU": "Cuscatlan",
      "LI": "La Libertad",
      "PA": "La Paz",
      "UN": "La Union",
      "MO": "Morazan",
      "SM": "San Miguel",
      "SS": "San Salvador",
      "SV": "San Vicente",
      "SA": "Santa Ana",
      "SO": "Sonsonate",
      "US": "Usulutan"
    },
    "callingCodes": ["503"],
    "ISO2digit": "SV",
    "ISO3digit": "SLV",
    "allowed": true
  },
  "GQ": {
    "name": "Equatorial Guinea",
    "provinces": {
      "AN": "Annobon",
      "BN": "Bioko Norte",
      "BS": "Bioko Sur",
      "CS": "Centro Sur",
      "KN": "Kie-Ntem",
      "LI": "Litoral",
      "WN": "Wele-Nzas"
    },
    "callingCodes": ["240"],
    "ISO2digit": "GQ",
    "ISO3digit": "GNQ",
    "allowed": true
  },
  "ER": {
    "name": "Eritrea",
    "provinces": {
      "MA": "Al Awsat",
      "DU": "Al Janubi",
      "AN": "Ansaba",
      "DK": "Janubi al Bahri al Ahmar",
      "GB": "Qash-Barkah",
      "SK": "Shimali al Bahri al Ahmar"
    },
    "callingCodes": ["291"],
    "ISO2digit": "ER",
    "ISO3digit": "ERI",
    "allowed": true
  },
  "EE": {
    "name": "Estonia",
    "provinces": {
      "37": "Harjumaa",
      "39": "Hiiumaa",
      "44": "Ida-Virumaa",
      "51": "Jarvamaa",
      "49": "Jogevamaa",
      "59": "Laane-Virumaa",
      "57": "Laanemaa",
      "67": "Parnumaa",
      "65": "Polvamaa",
      "70": "Raplamaa",
      "74": "Saaremaa",
      "78": "Tartumaa",
      "82": "Valgamaa",
      "84": "Viljandimaa",
      "86": "Vorumaa"
    },
    "callingCodes": ["372"],
    "ISO2digit": "EE",
    "ISO3digit": "EST",
    "allowed": false
  },
  "ET": {
    "name": "Ethiopia",
    "provinces": {
      "AA": "Adis Abeba",
      "AF": "Afar",
      "AM": "Amara",
      "BE": "Binshangul Gumuz",
      "DD": "Dire Dawa",
      "GA": "Gambela Hizboch",
      "HA": "Hareri Hizb",
      "OR": "Oromiya",
      "SO": "Sumale",
      "TI": "Tigray",
      "SN": "YeDebub Biheroch Bihereseboch na Hizboch"
    },
    "callingCodes": ["251"],
    "ISO2digit": "ET",
    "ISO3digit": "ETH",
    "allowed": true
  },
  "FK": {
    "name": "Falkland Islands",
    "provinces": ["Falkland Islands"],
    "callingCodes": ["500"],
    "ISO2digit": "FK",
    "ISO3digit": "FLK",
    "allowed": true
  },
  "FO": {
    "name": "Faroe Islands",
    "provinces": [
      "Eysturoy",
      "Nordoyar",
      "Sandoy",
      "Streymoy",
      "Suduroy",
      "Vagar"
    ],
    "callingCodes": ["298"],
    "ISO2digit": "FO",
    "ISO3digit": "FRO",
    "allowed": true
  },
  "FJ": {
    "name": "Fiji",
    "provinces": {
      "C": "Central",
      "E": "Eastern",
      "N": "Northern",
      "W": "Western",
      "R": "Rotuma"
    },
    "callingCodes": ["679"],
    "ISO2digit": "FJ",
    "ISO3digit": "FJI",
    "allowed": true
  },
  "FI": {
    "name": "Finland",
    "provinces": {
      "01": "Ahvenanmaan maakunta",
      "02": "Etela-Karjala",
      "03": "Etela-Pohjanmaa",
      "04": "Etela-Savo",
      "05": "Kainuu",
      "06": "Kanta-Hame",
      "07": "Keski-Pohjanmaa",
      "08": "Keski-Suomi",
      "09": "Kymenlaakso",
      "10": "Lappi",
      "16": "Paijat-Hame",
      "11": "Pirkanmaa",
      "12": "Pohjanmaa",
      "13": "Pohjois-Karjala",
      "14": "Pohjois-Pohjanmaa",
      "15": "Pohjois-Savo",
      "17": "Satakunta",
      "18": "Uusimaa",
      "19": "Varsinais-Suomi"
    },
    "callingCodes": ["358"],
    "ISO2digit": "FI",
    "ISO3digit": "FIN",
    "allowed": true
  },
  "FR": {
    "name": "France",
    "provinces": {
      "ARA": "Auvergne-Rhone-Alpes",
      "BFC": "Bourgogne-Franche-Comte",
      "BRE": "Bretagne",
      "CVL": "Centre-Val de Loire",
      "COR": "Corse",
      "GES": "Grand Est",
      "HDF": "Hauts-de-France",
      "IDF": "Ile-de-France",
      "NOR": "Normandie",
      "NAQ": "Nouvelle-Aquitaine",
      "OCC": "Occitanie",
      "PDL": "Pays de la Loire",
      "PAC": "Provence-Alpes-Cote d'Azur"
    },
    "callingCodes": ["33"],
    "ISO2digit": "FR",
    "ISO3digit": "FRA",
    "allowed": false
  },
  "GF": {
    "name": "French Guiana",
    "provinces": ["Cayenne,Saint-Laurent-du-Maroni"],
    "callingCodes": ["594"],
    "ISO2digit": "GF",
    "ISO3digit": "GUF",
    "allowed": false
  },
  "PF": {
    "name": "French Polynesia",
    "provinces": [
      "Iles Australes",
      "Iles du Vent",
      "Iles Marquises",
      "Iles Sous-le-Vent",
      "Iles Tuamotu-Gambier"
    ],
    "callingCodes": ["689"],
    "ISO2digit": "PF",
    "ISO3digit": "PYF",
    "allowed": false
  },
  "TF": {
    "name": "French Southern Territories",
    "provinces": [
      "Saint Paul / Ile Amsterdam",
      "Archipel Crozet",
      "Archipel des Kerguelen",
      "Terre Adelie",
      "Iles Eparsesa"
    ],
    "callingCodes": ["262"],
    "ISO2digit": "TF",
    "ISO3digit": "ATF",
    "allowed": false
  },
  "GA": {
    "name": "Gabon",
    "provinces": {
      "1": "Estuaire",
      "2": "Haut-Ogooue",
      "3": "Moyen-Ogooue",
      "4": "Ngounie",
      "5": "Nyanga",
      "6": "Ogooue-Ivindo",
      "7": "Ogooue-Lolo",
      "8": "Ogooue-Maritime",
      "9": "Woleu-Ntem"
    },
    "callingCodes": ["241"],
    "ISO2digit": "GA",
    "ISO3digit": "GAB",
    "allowed": true
  },
  "GM": {
    "name": "Gambia",
    "provinces": {
      "B": "Banjul",
      "M": "Central River",
      "L": "Lower River",
      "N": "North Bank",
      "U": "Upper River",
      "W": "Western"
    },
    "callingCodes": ["220"],
    "ISO2digit": "GM",
    "ISO3digit": "GMB",
    "allowed": true
  },
  "GE": {
    "name": "Georgia",
    "provinces": {
      "AB": "Abkhazia",
      "AJ": "Ajaria",
      "GU": "Guria",
      "IM": "Imereti",
      "KA": "K'akheti",
      "KK": "Kvemo Kartli",
      "MM": "Mtskheta-Mtianeti",
      "RL": "Rach'a-Lechkhumi-Kvemo Svaneti",
      "SZ": "Samegrelo-Zemo Svaneti",
      "SJ": "Samtskhe-Javakheti",
      "SK": "Shida Kartli",
      "TB": "Tbilisi"
    },
    "callingCodes": ["995"],
    "ISO2digit": "GE",
    "ISO3digit": "GEO",
    "allowed": true
  },
  "DE": {
    "name": "Germany",
    "provinces": {
      "BW": "Baden-Wurttemberg",
      "BY": "Bayern",
      "BE": "Berlin",
      "BB": "Brandenburg",
      "HB": "Bremen",
      "HH": "Hamburg",
      "HE": "Hessen",
      "MV": "Mecklenburg-Vorpommern",
      "NI": "Niedersachsen",
      "NW": "Nordrhein-Westfalen",
      "RP": "Rheinland-Pfalz",
      "SL": "Saarland",
      "SN": "Sachsen",
      "ST": "Sachsen-Anhalt",
      "SH": "Schleswig-Holstein",
      "TH": "Thuringen"
    },
    "callingCodes": ["49"],
    "ISO2digit": "DE",
    "ISO3digit": "DEU",
    "allowed": false
  },
  "GH": {
    "name": "Ghana",
    "provinces": {
      "AH": "Ashanti",
      "BA": "Brong-Ahafo",
      "CP": "Central",
      "EP": "Eastern",
      "AA": "Greater Accra",
      "NP": "Northern",
      "UE": "Upper East",
      "UW": "Upper West",
      "TV": "Volta",
      "WP": "Western"
    },
    "callingCodes": ["233"],
    "ISO2digit": "GH",
    "ISO3digit": "GHA",
    "allowed": true
  },
  "GI": {
    "name": "Gibraltar",
    "provinces": ["Gibraltar"],
    "callingCodes": ["350"],
    "ISO2digit": "GI",
    "ISO3digit": "GIB",
    "allowed": true
  },
  "GR": {
    "name": "Greece",
    "provinces": {
      "A": "Anatoliki Makedonia kai Thraki",
      "I": "Attiki",
      "G": "Dytiki Ellada",
      "C": "Dytiki Makedonia",
      "F": "Ionia Nisia",
      "D": "Ipeiros",
      "B": "Kentriki Makedonia",
      "M": "Kriti",
      "L": "Notio Aigaio",
      "J": "Peloponnisos",
      "H": "Sterea Ellada",
      "E": "Thessalia",
      "K": "Voreio Aigaio"
    },
    "callingCodes": ["30"],
    "ISO2digit": "GR",
    "ISO3digit": "GRC",
    "allowed": true
  },
  "GL": {
    "name": "Greenland",
    "provinces": {
      "KU": "Kommune Kujalleq",
      "SM": "Kommuneqarfik Sermersooq",
      "QA": "Qaasuitsup Kommunia",
      "QE": "Qeqqata Kommunia"
    },
    "callingCodes": ["299"],
    "ISO2digit": "GL",
    "ISO3digit": "GRL",
    "allowed": true
  },
  "GD": {
    "name": "Grenada",
    "provinces": {
      "01": "Saint Andrew",
      "02": "Saint David",
      "03": "Saint George",
      "04": "Saint John",
      "05": "Saint Mark",
      "06": "Saint Patrick",
      "10": "Southern Grenadine Islands"
    },
    "callingCodes": ["1473"],
    "ISO2digit": "GD",
    "ISO3digit": "GRD",
    "allowed": true
  },
  "GP": {
    "name": "Guadeloupe",
    "provinces": ["Basse-Terre,Pointe-a-Pitre"],
    "callingCodes": ["590"],
    "ISO2digit": "GP",
    "ISO3digit": "GLP",
    "allowed": false
  },
  "GU": {
    "name": "Guam",
    "provinces": [
      "Agana Heights",
      "Agat",
      "Asan-Maina",
      "Barrigada",
      "Chalan-Pago-Ordot",
      "Dededo",
      "Hagatna",
      "Inarajan",
      "Mangilao",
      "Merizo",
      "Mongmong-Toto-Maite",
      "Piti",
      "Santa Rita",
      "Sinajana",
      "Talofofo",
      "Tamuning (including Tumon)",
      "Umatac",
      "Yigo",
      "Yona"
    ],
    "callingCodes": ["1671"],
    "ISO2digit": "GU",
    "ISO3digit": "GUM",
    "allowed": true
  },
  "GT": {
    "name": "Guatemala",
    "provinces": {
      "AV": "Alta Verapaz",
      "BV": "Baja Verapaz",
      "CM": "Chimaltenango",
      "CQ": "Chiquimula",
      "PR": "El Progreso",
      "ES": "Escuintla",
      "GU": "Guatemala",
      "HU": "Huehuetenango",
      "IZ": "Izabal",
      "JA": "Jalapa",
      "JU": "Jutiapa",
      "PE": "Peten",
      "QZ": "Quetzaltenango",
      "QC": "Quiche",
      "RE": "Retalhuleu",
      "SA": "Sacatepequez",
      "SM": "San Marcos",
      "SR": "Santa Rosa",
      "SO": "Solola",
      "SU": "Suchitepequez",
      "TO": "Totonicapan",
      "ZA": "Zacapa"
    },
    "callingCodes": ["502"],
    "ISO2digit": "GT",
    "ISO3digit": "GTM",
    "allowed": true
  },
  "GG": {
    "name": "Guernsey",
    "provinces": [
      "Castel",
      "Forest",
      "St Andrew",
      "St Martin",
      "St Peter Port",
      "St Pierre du Bois",
      "St Sampson",
      "St Saviour",
      "Torteval",
      "Vale"
    ],
    "callingCodes": ["44"],
    "ISO2digit": "GG",
    "ISO3digit": "GGY",
    "allowed": false
  },
  "GN": {
    "name": "Guinea",
    "provinces": {
      "BE": "Beyla",
      "BF": "Boffa",
      "B": "Boke",
      "C": "Conakry",
      "CO": "Coyah",
      "DB": "Dabola",
      "DL": "Dalaba",
      "DI": "Dinguiraye",
      "DU": "Dubreka",
      "F": "Faranah",
      "FO": "Forecariah",
      "FR": "Fria",
      "GA": "Gaoual",
      "GU": "Guekedou",
      "K": "Kankan",
      "KE": "Kerouane",
      "D": "Kindia",
      "KS": "Kissidougou",
      "KB": "Koubia",
      "KN": "Koundara",
      "KO": "Kouroussa",
      "L": "Labe",
      "LE": "Lelouma",
      "LO": "Lola",
      "MC": "Macenta",
      "ML": "Mali",
      "M": "Mamou",
      "MD": "Mandiana",
      "N": "Nzerekore",
      "PI": "Pita",
      "SI": "Siguiri",
      "TE": "Telimele",
      "TO": "Tougue",
      "YO": "Yomou"
    },
    "callingCodes": ["224"],
    "ISO2digit": "GN",
    "ISO3digit": "GIN",
    "allowed": true
  },
  "GW": {
    "name": "Guinea-Bissau",
    "provinces": {
      "BA": "Bafata",
      "BM": "Biombo",
      "BS": "Bissau",
      "BL": "Bolama",
      "CA": "Cacheu",
      "GA": "Gabu",
      "OI": "Oio",
      "QU": "Quinara",
      "TO": "Tombali"
    },
    "callingCodes": ["245"],
    "ISO2digit": "GW",
    "ISO3digit": "GNB",
    "allowed": true
  },
  "GY": {
    "name": "Guyana",
    "provinces": {
      "BA": "Barima-Waini",
      "CU": "Cuyuni-Mazaruni",
      "DE": "Demerara-Mahaica",
      "EB": "East Berbice-Corentyne",
      "ES": "Essequibo Islands-West Demerara",
      "MA": "Mahaica-Berbice",
      "PM": "Pomeroon-Supenaam",
      "PT": "Potaro-Siparuni",
      "UD": "Upper Demerara-Berbice",
      "UT": "Upper Takutu-Upper Essequibo"
    },
    "callingCodes": ["592"],
    "ISO2digit": "GY",
    "ISO3digit": "GUY",
    "allowed": true
  },
  "HT": {
    "name": "Haiti",
    "provinces": {
      "AR": "Artibonite",
      "CE": "Centre",
      "GA": "Grande'Anse",
      "NI": "Nippes",
      "ND": "Nord",
      "NE": "Nord-Est",
      "NO": "Nord-Ouest",
      "OU": "Ouest",
      "SD": "Sud",
      "SE": "Sud-Est"
    },
    "callingCodes": ["509"],
    "ISO2digit": "HT",
    "ISO3digit": "HTI",
    "allowed": true
  },
  "HM": {
    "name": "Heard Island and McDonald Islands",
    "provinces": ["Heard Island and McDonald Islands"],
    "callingCodes": ["672"],
    "ISO2digit": "HM",
    "ISO3digit": "HMD",
    "allowed": true
  },
  "HN": {
    "name": "Honduras",
    "provinces": {
      "AT": "Atlantida",
      "CH": "Choluteca",
      "CL": "Colon",
      "CM": "Comayagua",
      "CP": "Copan",
      "CR": "Cortes",
      "EP": "El Paraiso",
      "FM": "Francisco Morazan",
      "GD": "Gracias a Dios",
      "IN": "Intibuca",
      "IB": "Islas de la Bahia",
      "LP": "La Paz",
      "LE": "Lempira",
      "OC": "Ocotepeque",
      "OL": "Olancho",
      "SB": "Santa Barbara",
      "VA": "Valle",
      "YO": "Yoro"
    },
    "callingCodes": ["504"],
    "ISO2digit": "HN",
    "ISO3digit": "HND",
    "allowed": true
  },
  "HK": {
    "name": "Hong Kong",
    "provinces": [
      "Central and Western",
      "Eastern",
      "Southern",
      "Wan Chai",
      "Sham Shui Po",
      "Kowloon City",
      "Kwun Tong",
      "Wong Tai Sin",
      "Yau Tsim Mong",
      "Islands",
      "Kwai Tsing",
      "North",
      "Sai Kung",
      "Sha Tin",
      "Tai Po",
      "Tsuen Wan",
      "Tuen Mun",
      "Yuen Long"
    ],
    "callingCodes": ["852"],
    "ISO2digit": "HK",
    "ISO3digit": "HKG",
    "allowed": true
  },
  "HU": {
    "name": "Hungary",
    "provinces": {
      "BK": "Bács-Kiskun",
      "BA": "Baranya",
      "BE": "Békés",
      "BC": "Békéscsaba",
      "BZ": "Borsod-Abaúj-Zemplén",
      "BU": "Budapest",
      "CS": "Csongrád",
      "DE": "Debrecen",
      "DU": "Dunaújváros",
      "EG": "Eger",
      "ER": "Érd",
      "FE": "Fejér",
      "GY": "Gyor",
      "GS": "Gyor-Moson-Sopron",
      "HB": "Hajdú-Bihar",
      "HE": "Heves",
      "HV": "Hódmezovásárhely",
      "JN": "Jász-Nagykun-Szolnok",
      "KV": "Kaposvár",
      "KM": "Kecskemét",
      "KE": "Komárom-Esztergom",
      "MI": "Miskolc",
      "NK": "Nagykanizsa",
      "NO": "Nógrád",
      "NY": "Nyíregyháza",
      "PS": "Pécs",
      "PE": "Pest",
      "ST": "Salgótarján",
      "SO": "Somogy",
      "SN": "Sopron",
      "SZ": "Szabolcs-Szatmár-Bereg",
      "SD": "Szeged",
      "SF": "Székesfehérvár",
      "SS": "Szekszárd",
      "SK": "Szolnok",
      "SH": "Szombathely",
      "TB": "Tatabánya",
      "TO": "Tolna",
      "VA": "Vas",
      "VE": "Veszprém",
      "VM": "Veszprém",
      "ZA": "Zala",
      "ZE": "Zalaegerszeg"
    },
    "callingCodes": ["36"],
    "ISO2digit": "HU",
    "ISO3digit": "HUN",
    "allowed": true
  },
  "IS": {
    "name": "Iceland",
    "provinces": {
      "7": "Austurland",
      "1": "Hofudborgarsvaedi utan Reykjavikur",
      "6": "Nordurland eystra",
      "5": "Nordurland vestra",
      "8": "Sudurland",
      "2": "Sudurnes",
      "4": "Vestfirdir",
      "3": "Vesturland"
    },
    "callingCodes": ["354"],
    "ISO2digit": "IS",
    "ISO3digit": "ISL",
    "allowed": true
  },
  "IN": {
    "name": "India",
    "provinces": {
      "AN": "Andaman and Nicobar Islands",
      "AP": "Andhra Pradesh",
      "AR": "Arunachal Pradesh",
      "AS": "Assam",
      "BR": "Bihar",
      "CH": "Chandigarh",
      "CT": "Chhattisgarh",
      "DN": "Dadra and Nagar Haveli",
      "DD": "Daman and Diu",
      "DL": "Delhi",
      "GA": "Goa",
      "GJ": "Gujarat",
      "HR": "Haryana",
      "HP": "Himachal Pradesh",
      "JK": "Jammu and Kashmir",
      "JH": "Jharkhand",
      "KA": "Karnataka",
      "KL": "Kerala",
      "LD": "Lakshadweep",
      "MP": "Madhya Pradesh",
      "MH": "Maharashtra",
      "MN": "Manipur",
      "ML": "Meghalaya",
      "MZ": "Mizoram",
      "NL": "Nagaland",
      "OR": "Odisha",
      "PY": "Puducherry",
      "PB": "Punjab",
      "RJ": "Rajasthan",
      "SK": "Sikkim",
      "TN": "Tamil Nadu",
      "TG": "Telangana",
      "TR": "Tripura",
      "UP": "Uttar Pradesh",
      "UT": "Uttarakhand",
      "WB": "West Bengal"
    },
    "callingCodes": ["91"],
    "ISO2digit": "IN",
    "ISO3digit": "IND",
    "allowed": true
  },
  "ID": {
    "name": "Indonesia",
    "provinces": {
      "AC": "Aceh",
      "BA": "Bali",
      "BT": "Banten",
      "BE": "Bengkulu",
      "GO": "Gorontalo",
      "JK": "Jakarta Raya",
      "JA": "Jambi",
      "JB": "Jawa Barat",
      "JT": "Jawa Tengah",
      "JI": "Jawa Timur",
      "KB": "Kalimantan Barat",
      "KS": "Kalimantan Selatan",
      "KT": "Kalimantan Tengah",
      "KI": "Kalimantan Timur",
      "BB": "Kepulauan Bangka Belitung",
      "KR": "Kepulauan Riau",
      "LA": "Lampung",
      "ML": "Maluku",
      "MU": "Maluku Utara",
      "NB": "Nusa Tenggara Barat",
      "NT": "Nusa Tenggara Timur",
      "PP": "Papua",
      "PB": "Papua Barat",
      "RI": "Riau",
      "SR": "Sulawesi Barat",
      "SN": "Sulawesi Selatan",
      "ST": "Sulawesi Tengah",
      "SG": "Sulawesi Tenggara",
      "SA": "Sulawesi Utara",
      "SB": "Sumatera Barat",
      "SS": "Sumatera Selatan",
      "SU": "Sumatera Utara",
      "YO": "Yogyakarta"
    },
    "callingCodes": ["62"],
    "ISO2digit": "ID",
    "ISO3digit": "IDN",
    "allowed": true
  },
  "IR": {
    "name": "Iran, Islamic Republic of",
    "provinces": {
      "32": "Alborz",
      "03": "Ardabil",
      "02": "Azarbayjan-e Gharbi",
      "01": "Azarbayjan-e Sharqi",
      "06": "Bushehr",
      "08": "Chahar Mahal va Bakhtiari",
      "04": "Esfahan",
      "14": "Fars",
      "19": "Gilan",
      "27": "Golestan",
      "24": "Hamadan",
      "23": "Hormozgan",
      "05": "Ilam",
      "15": "Kerman",
      "17": "Kermanshah",
      "29": "Khorasan-e Jonubi",
      "30": "Khorasan-e Razavi",
      "31": "Khorasan-e Shomali",
      "10": "Khuzestan",
      "18": "Kohgiluyeh va Bowyer Ahmad",
      "16": "Kordestan",
      "20": "Lorestan",
      "22": "Markazi",
      "21": "Mazandaran",
      "28": "Qazvin",
      "26": "Qom",
      "12": "Semnan",
      "13": "Sistan va Baluchestan",
      "07": "Tehran",
      "25": "Yazd",
      "11": "Zanjan"
    },
    "callingCodes": ["98"],
    "ISO2digit": "IR",
    "ISO3digit": "IRN",
    "allowed": false
  },
  "IQ": {
    "name": "Iraq",
    "provinces": {
      "AN": "Al Anbar",
      "BA": "Al Basrah",
      "MU": "Al Muthanna",
      "QA": "Al Qadisiyah",
      "NA": "An Najaf",
      "AR": "Arbil",
      "SU": "As Sulaymaniyah",
      "BB": "Babil",
      "BG": "Baghdad",
      "DA": "Dahuk",
      "DQ": "Dhi Qar",
      "DI": "Diyala",
      "KA": "Karbala'",
      "KI": "Kirkuk",
      "MA": "Maysan",
      "NI": "Ninawa",
      "SD": "Salah ad Din",
      "WA": "Wasit"
    },
    "callingCodes": ["964"],
    "ISO2digit": "IQ",
    "ISO3digit": "IRQ",
    "allowed": false
  },
  "IE": {
    "name": "Ireland",
    "provinces": {
      "C": "Connacht",
      "L": "Leinster",
      "M": "Munster",
      "U": "Ulster"
    },
    "callingCodes": ["353"],
    "ISO2digit": "IE",
    "ISO3digit": "IRL",
    "allowed": true
  },
  "IM": {
    "name": "Isle of Man",
    "provinces": ["Isle of Man"],
    "callingCodes": ["44"],
    "ISO2digit": "IM",
    "ISO3digit": "IMN",
    "allowed": true
  },
  "IL": {
    "name": "Israel",
    "provinces": {
      "D": "HaDarom",
      "M": "HaMerkaz",
      "Z": "HaTsafon",
      "HA": "Hefa",
      "TA": "Tel Aviv",
      "JM": "Yerushalayim"
    },
    "callingCodes": ["972"],
    "ISO2digit": "IL",
    "ISO3digit": "ISR",
    "allowed": false
  },
  "IT": {
    "name": "Italy",
    "provinces": {
      "65": "Abruzzo",
      "77": "Basilicata",
      "78": "Calabria",
      "72": "Campania",
      "45": "Emilia-Romagna",
      "36": "Friuli-Venezia Giulia",
      "62": "Lazio",
      "42": "Liguria",
      "25": "Lombardia",
      "57": "Marche",
      "67": "Molise",
      "21": "Piemonte",
      "75": "Puglia",
      "88": "Sardegna",
      "82": "Sicilia",
      "52": "Toscana",
      "32": "Trentino-Alto Adige",
      "55": "Umbria",
      "23": "Valle d'Aosta",
      "34": "Veneto"
    },
    "callingCodes": ["39"],
    "ISO2digit": "IT",
    "ISO3digit": "ITA",
    "allowed": true
  },
  "JM": {
    "name": "Jamaica",
    "provinces": {
      "13": "Clarendon",
      "09": "Hanover",
      "01": "Kingston",
      "12": "Manchester",
      "04": "Portland",
      "02": "Saint Andrew",
      "06": "Saint Ann",
      "14": "Saint Catherine",
      "11": "Saint Elizabeth",
      "08": "Saint James",
      "05": "Saint Mary",
      "03": "Saint Thomas",
      "07": "Trelawny",
      "10": "Westmoreland"
    },
    "callingCodes": ["1876"],
    "ISO2digit": "JM",
    "ISO3digit": "JAM",
    "allowed": true
  },
  "JP": {
    "name": "Japan",
    "provinces": {
      "23": "Aichi",
      "05": "Akita",
      "02": "Aomori",
      "12": "Chiba",
      "38": "Ehime",
      "18": "Fukui",
      "40": "Fukuoka",
      "07": "Fukushima",
      "21": "Gifu",
      "10": "Gunma",
      "34": "Hiroshima",
      "01": "Hokkaido",
      "28": "Hyogo",
      "08": "Ibaraki",
      "17": "Ishikawa",
      "03": "Iwate",
      "37": "Kagawa",
      "46": "Kagoshima",
      "14": "Kanagawa",
      "39": "Kochi",
      "43": "Kumamoto",
      "26": "Kyoto",
      "24": "Mie",
      "04": "Miyagi",
      "45": "Miyazaki",
      "20": "Nagano",
      "42": "Nagasaki",
      "29": "Nara",
      "15": "Niigata",
      "44": "Oita",
      "33": "Okayama",
      "47": "Okinawa",
      "27": "Osaka",
      "41": "Saga",
      "11": "Saitama",
      "25": "Shiga",
      "32": "Shimane",
      "22": "Shizuoka",
      "09": "Tochigi",
      "36": "Tokushima",
      "13": "Tokyo",
      "31": "Tottori",
      "16": "Toyama",
      "30": "Wakayama",
      "06": "Yamagata",
      "35": "Yamaguchi",
      "19": "Yamanashi"
    },
    "callingCodes": ["81"],
    "ISO2digit": "JP",
    "ISO3digit": "JPN",
    "allowed": true
  },
  "JE": {
    "name": "Jersey",
    "provinces": [
      "Saint Helier",
      "Grouville",
      "Saint Brelade",
      "Saint Clement",
      "Saint John",
      "Saint Lawrence",
      "Saint Martin",
      "Saint Mary",
      "Saint Ouen",
      "Saint Peter",
      "Saint Saviour",
      "Trinity"
    ],
    "callingCodes": ["44"],
    "ISO2digit": "JE",
    "ISO3digit": "JEY",
    "allowed": false
  },
  "JO": {
    "name": "Jordan",
    "provinces": {
      "AJ": "'Ajlun",
      "AQ": "Al 'Aqabah",
      "BA": "Al Balqā'",
      "KA": "Al Karak",
      "MA": "Al Mafraq",
      "AM": "Al 'Asimah",
      "AT": "At Tafilah",
      "AZ": "Az Zarqa'",
      "IR": "Irbid",
      "JA": "Jarash",
      "MN": "Ma'an",
      "MD": "Madaba"
    },
    "callingCodes": ["962"],
    "ISO2digit": "JO",
    "ISO3digit": "JOR",
    "allowed": true
  },
  "KZ": {
    "name": "Kazakhstan",
    "provinces": {
      "ALA": "Almaty",
      "AST": "Astana",
      "ALM": "Almaty oblysy",
      "AKM": "Aqmola oblysy",
      "AKT": "Aqtöbe oblysy",
      "ATY": "Atyrau oblysy",
      "BAY": "Bayqongyr",
      "ZAP": "Batys Qazaqstan oblysy",
      "MAN": "Mangghystau oblysy",
      "YUZ": "Ongtüstik Qazaqstan oblysy",
      "PAV": "Pavlodar oblysy",
      "KAR": "Qaraghandy oblysy",
      "KUS": "Qostanay oblysy",
      "KZY": "Qyzylorda oblysy",
      "VOS": "Shyghys Qazaqstan oblysy",
      "SEV": "Soltüstik Qazaqstan oblysy",
      "ZHA": "Zhambyl oblysy"
    },
    "callingCodes": ["76", "77"],
    "ISO2digit": "KZ",
    "ISO3digit": "KAZ",
    "allowed": true
  },
  "KE": {
    "name": "Kenya",
    "provinces": {
      "1": "Baringo",
      "2": "Bomet",
      "3": "Bungoma",
      "4": "Busia",
      "5": "Elgeyo/Marakwet",
      "6": "Embu",
      "7": "Garissa",
      "8": "Homa Bay",
      "9": "Isiolo",
      "10": "Kajiado",
      "11": "Kakamega",
      "12": "Kericho",
      "13": "Kiambu",
      "14": "Kilifi",
      "15": "Kirinyaga",
      "16": "Kisii",
      "17": "Kisumu",
      "18": "Kitui",
      "19": "Kwale",
      "20": "Laikipia",
      "21": "Lamu",
      "22": "Machakos",
      "23": "Makueni",
      "24": "Mandera",
      "25": "Marsabit",
      "26": "Meru",
      "27": "Migori",
      "28": "Mombasa",
      "29": "Murang'a",
      "30": "Nairobi City",
      "31": "Nakuru",
      "32": "Nandi",
      "33": "Narok",
      "34": "Nyamira",
      "35": "Nyandarua",
      "36": "Nyeri",
      "37": "Samburu",
      "38": "Siaya",
      "39": "Taita/Taveta",
      "40": "Tana River",
      "41": "Tharaka-Nithi",
      "42": "Trans Nzoia",
      "43": "Turkana",
      "44": "Uasin Gishu",
      "45": "Vihiga",
      "46": "Wajir",
      "47": "West Pokot"
    },
    "callingCodes": ["254"],
    "ISO2digit": "KE",
    "ISO3digit": "KEN",
    "allowed": true
  },
  "KI": {
    "name": "Kiribati",
    "provinces": {
      "G": "Gilbert Islands",
      "L": "Line Islands",
      "P": "Phoenix Islands"
    },
    "callingCodes": ["686"],
    "ISO2digit": "KI",
    "ISO3digit": "KIR",
    "allowed": true
  },
  "KP": {
    "name": "Korea, Democratic People's Republic of",
    "provinces": {
      "4": "Chagang",
      "7": "Kangwon",
      "9": "North Hamgyong",
      "6": "North Hwanghae",
      "3": "North Pyongan",
      "1": "Pyongyang",
      "13": "Rason",
      "10": "Ryanggang",
      "8": "South Hamgyong",
      "5": "South Hwanghae",
      "2": "South Pyongan"
    },
    "callingCodes": ["850"],
    "ISO2digit": "KP",
    "ISO3digit": "PRK",
    "allowed": true
  },
  "KR": {
    "name": "Korea, Republic of",
    "provinces": {
      "26": "Busan",
      "27": "Daegu",
      "30": "Daejeon",
      "42": "Gangwon",
      "29": "Gwangju",
      "41": "Gyeonggi",
      "28": "Incheon",
      "49": "Jeju",
      "43": "North Chungcheong",
      "47": "North Gyeongsang",
      "45": "North Jeolla",
      "50": "Sejong",
      "11": "Seoul",
      "44": "South Chungcheong",
      "48": "South Gyeongsang",
      "46": "South Jeolla",
      "31": "Ulsan"
    },
    "callingCodes": ["82"],
    "ISO2digit": "KR",
    "ISO3digit": "KOR",
    "allowed": true
  },
  "XK": {
    "name": "Kosovo, Republic of",
    "provinces": [
      "Peja",
      "Mitrovica",
      "Pristina",
      "Gjilan",
      "Gjakova",
      "Prizren",
      "Ferizaj"
    ],
    "callingCodes": ["383"],
    "ISO2digit": "XK",
    "ISO3digit": "KOS",
    "allowed": false
  },
  "KW": {
    "name": "Kuwait",
    "provinces": {
      "AH": "Al Ahmadi",
      "FA": "Al Farwaniyah",
      "JA": "Al Jahra'",
      "KU": "Al 'Asimah",
      "HA": "Hawalli",
      "MU": "Mubarak al Kabir"
    },
    "callingCodes": ["965"],
    "ISO2digit": "KW",
    "ISO3digit": "KWT",
    "allowed": true
  },
  "KG": {
    "name": "Kyrgyzstan",
    "provinces": {
      "B": "Batken",
      "GB": "Bishkek",
      "C": "Chü",
      "J": "Jalal-Abad",
      "N": "Naryn",
      "GO": "Osh",
      "O": "Osh",
      "T": "Talas",
      "Y": "Ysyk-Köl"
    },
    "callingCodes": ["996"],
    "ISO2digit": "KG",
    "ISO3digit": "KGZ",
    "allowed": true
  },
  "LA": {
    "name": "Lao, People's Democratic Republic",
    "provinces": {
      "AT": "Attapu",
      "BK": "Bokèo",
      "BL": "Bolikhamsai",
      "CH": "Champasak",
      "HO": "Houaphan",
      "KH": "Khammouan",
      "LM": "Louang Namtha",
      "LP": "Louangphabang",
      "OU": "Oudômxai",
      "PH": "Phôngsali",
      "SL": "Salavan",
      "SV": "Savannakhét",
      "VI": "Vientiane",
      "VT": "Vientiane",
      "XA": "Xaignabouli",
      "XE": "Xékong",
      "XI": "Xiangkhouang",
      "XS": "Xaisômboun"
    },
    "callingCodes": ["856"],
    "ISO2digit": "LA",
    "ISO3digit": "LAO",
    "allowed": true
  },
  "LV": {
    "name": "Latvia",
    "provinces": {
      "1": "Aglona",
      "2": "Aizkraukle",
      "3": "Aizpute",
      "4": "Akniste",
      "5": "Aloja",
      "6": "Alsunga",
      "7": "Aluksne",
      "8": "Amata",
      "9": "Ape",
      "10": "Auce",
      "11": "Adaži",
      "12": "Babite",
      "13": "Baldone",
      "14": "Baltinava",
      "15": "Balvi",
      "16": "Bauska",
      "17": "Beverina",
      "18": "Broceni",
      "19": "Burtnieki",
      "20": "Carnikava",
      "21": "Cesvaine",
      "22": "Cesis",
      "23": "Cibla",
      "24": "Dagda",
      "25": "Daugavpils",
      "26": "Dobele",
      "27": "Dundaga",
      "28": "Durbe",
      "29": "Engure",
      "30": "Ergli",
      "31": "Garkalne",
      "32": "Grobina",
      "33": "Gulbene",
      "34": "Iecava",
      "35": "Ikškile",
      "36": "Ilukste",
      "37": "Incukalns",
      "38": "Jaunjelgava",
      "39": "Jaunpiebalga",
      "40": "Jaunpils",
      "41": "Jelgava",
      "42": "Jekabpils",
      "43": "Kandava",
      "44": "Karsava",
      "45": "Koceni",
      "46": "Koknese",
      "47": "Kraslava",
      "48": "Krimulda",
      "49": "Krustpils",
      "50": "Kuldiga",
      "51": "Kegums",
      "52": "Kekava",
      "53": "Lielvarde",
      "54": "Limbaži",
      "55": "Ligatne",
      "56": "Livani",
      "57": "Lubana",
      "58": "Ludza",
      "59": "Madona",
      "60": "Mazsalaca",
      "61": "Malpils",
      "62": "Marupe",
      "63": "Mersrags",
      "64": "Naukšeni",
      "65": "Nereta",
      "66": "Nica",
      "67": "Ogre",
      "68": "Olaine",
      "69": "Ozolnieki",
      "70": "Pargauja",
      "71": "Pavilosta",
      "72": "Plavinas",
      "73": "Preili",
      "74": "Priekule",
      "75": "Priekuli",
      "76": "Rauna",
      "77": "Rezekne",
      "78": "Riebini",
      "79": "Roja",
      "80": "Ropaži",
      "81": "Rucava",
      "82": "Rugaji",
      "83": "Rundale",
      "84": "Rujiena",
      "85": "Sala",
      "86": "Salacgriva",
      "87": "Salaspils",
      "88": "Saldus",
      "89": "Saulkrasti",
      "90": "Seja",
      "91": "Sigulda",
      "92": "Skriveri",
      "93": "Skrunda",
      "94": "Smiltene",
      "95": "Stopini",
      "96": "Strenci",
      "97": "Talsi",
      "98": "Tervete",
      "99": "Tukums",
      "100": "Vainode",
      "101": "Valka",
      "102": "Varaklani",
      "103": "Varkava",
      "104": "Vecpiebalga",
      "105": "Vecumnieki",
      "106": "Ventspils",
      "107": "Viesite",
      "108": "Vilaka",
      "109": "Vilani",
      "110": "Zilupe"
    },
    "callingCodes": ["371"],
    "ISO2digit": "LV",
    "ISO3digit": "LVA",
    "allowed": true
  },
  "LB": {
    "name": "Lebanon",
    "provinces": {
      "AK": "Aakkâr",
      "BH": "Baalbek-Hermel",
      "BI": "Béqaa",
      "BA": "Beyrouth",
      "AS": "Liban-Nord",
      "JA": "Liban-Sud",
      "JL": "Mont-Liban",
      "NA": "Nabatîyé"
    },
    "callingCodes": ["961"],
    "ISO2digit": "LB",
    "ISO3digit": "LBN",
    "allowed": true
  },
  "LS": {
    "name": "Lesotho",
    "provinces": {
      "D": "Berea",
      "B": "Butha-Buthe",
      "C": "Leribe",
      "E": "Mafeteng",
      "A": "Maseru",
      "F": "Mohale's Hoek",
      "J": "Mokhotlong",
      "H": "Qacha's Nek",
      "G": "Quthing",
      "K": "Thaba-Tseka"
    },
    "callingCodes": ["266"],
    "ISO2digit": "LS",
    "ISO3digit": "LSO",
    "allowed": true
  },
  "LR": {
    "name": "Liberia",
    "provinces": {
      "BM": "Bomi",
      "BG": "Bong",
      "GP": "Gbarpolu",
      "GB": "Grand Bassa",
      "CM": "Grand Cape Mount",
      "GG": "Grand Gedeh",
      "GK": "Grand Kru",
      "LO": "Lofa",
      "MG": "Margibi",
      "MY": "Maryland",
      "MO": "Montserrado",
      "NI": "Nimba",
      "RI": "River Cess",
      "RG": "River Gee",
      "SI": "Sinoe"
    },
    "callingCodes": ["231"],
    "ISO2digit": "LR",
    "ISO3digit": "LBR",
    "allowed": true
  },
  "LY": {
    "name": "Libya",
    "provinces": {
      "BU": "Al Buţnān",
      "JA": "Al Jabal al Akhḑar",
      "JG": "Al Jabal al Gharbī",
      "JI": "Al Jafārah",
      "JU": "Al Jufrah",
      "KF": "Al Kufrah",
      "MJ": "Al Marj",
      "MB": "Al Marqab",
      "WA": "Al Wāḩāt",
      "NQ": "An Nuqaţ al Khams",
      "ZA": "Az Zāwiyah",
      "BA": "Banghāzī",
      "DR": "Darnah",
      "GT": "Ghāt",
      "MI": "Mişrātah",
      "MQ": "Murzuq",
      "NL": "Nālūt",
      "SB": "Sabhā",
      "SR": "Surt",
      "TB": "Ţarābulus",
      "WD": "Wādī al Ḩayāt",
      "WS": "Wādī ash Shāţiʾ"
    },
    "callingCodes": ["218"],
    "ISO2digit": "LY",
    "ISO3digit": "LBY",
    "allowed": true
  },
  "LI": {
    "name": "Liechtenstein",
    "provinces": {
      "01": "Balzers",
      "02": "Eschen",
      "03": "Gamprin",
      "04": "Mauren",
      "05": "Planken",
      "06": "Ruggell",
      "07": "Schaan",
      "08": "Schellenberg",
      "09": "Triesen",
      "10": "Triesenberg",
      "11": "Vaduz"
    },
    "callingCodes": ["423"],
    "ISO2digit": "LI",
    "ISO3digit": "LIE",
    "allowed": true
  },
  "LT": {
    "name": "Lithuania",
    "provinces": {
      "AL": "Alytaus Apskritis",
      "KU": "Kauno Apskritis",
      "KL": "Klaipėdos Apskritis",
      "MR": "Marijampolės Apskritis",
      "PN": "Panevėžio Apskritis",
      "SA": "Šiaulių Apskritis",
      "TA": "Tauragės Apskritis",
      "TE": "Telšių Apskritis",
      "UT": "Utenos Apskritis",
      "VL": "Vilniaus Apskritis"
    },
    "callingCodes": ["370"],
    "ISO2digit": "LT",
    "ISO3digit": "LTU",
    "allowed": true
  },
  "LU": {
    "name": "Luxembourg",
    "provinces": {
      "CA": "Capellen",
      "CL": "Clervaux",
      "DI": "Diekirch",
      "EC": "Echternach",
      "ES": "Esch-sur-Alzette",
      "GR": "Grevenmacher",
      "LU": "Luxembourg",
      "ME": "Mersch",
      "RD": "Redange",
      "RM": "Remich",
      "VD": "Vianden",
      "WI": "Wiltz"
    },
    "callingCodes": ["352"],
    "ISO2digit": "LU",
    "ISO3digit": "LUX",
    "allowed": true
  },
  "MO": {
    "name": "Macau",
    "provinces": [
      "Ilhas",
      "Macau"
    ],
    "callingCodes": ["853"],
    "ISO2digit": "MO",
    "ISO3digit": "MAC",
    "allowed": true
  },
  "MK": {
    "name": "Macedonia",
    "provinces": {
      "02": "Aračinovo",
      "03": "Berovo",
      "04": "Bitola",
      "05": "Bogdanci",
      "06": "Bogovinje",
      "07": "Bosilovo",
      "08": "Brvenica",
      "78": "Centar Župa",
      "80": "Čaška",
      "81": "Češinovo-Obleševo",
      "82": "Čučer Sandevo",
      "21": "Debar",
      "22": "Debarca",
      "23": "Delčevo",
      "25": "Demir Hisar",
      "24": "Demir Kapija",
      "26": "Dojran",
      "27": "Dolneni",
      "18": "Gevgelija",
      "19": "Gostivar",
      "20": "Gradsko",
      "34": "Ilinden",
      "35": "Jegunovce",
      "37": "Karbinci",
      "36": "Kavadarci",
      "40": "Kičevo",
      "42": "Kočani",
      "41": "Konče",
      "43": "Kratovo",
      "44": "Kriva Palanka",
      "45": "Krivogaštani",
      "46": "Kruševo",
      "47": "Kumanovo",
      "48": "Lipkovo",
      "49": "Lozovo",
      "51": "Makedonska Kamenica",
      "52": "Makedonski Brod",
      "50": "Mavrovo i Rostuša",
      "53": "Mogila",
      "54": "Negotino",
      "55": "Novaci",
      "56": "Novo Selo",
      "58": "Ohrid",
      "60": "Pehčevo",
      "59": "Petrovec",
      "61": "Plasnica",
      "62": "Prilep",
      "63": "Probištip",
      "64": "Radoviš",
      "65": "Rankovce",
      "66": "Resen",
      "67": "Rosoman",
      "85": "Skopje",
      "70": "Sopište",
      "71": "Staro Nagoričane",
      "72": "Struga",
      "73": "Strumica",
      "74": "Studeničani",
      "69": "Sveti Nikole",
      "83": "Štip",
      "75": "Tearce",
      "76": "Tetovo",
      "10": "Valandovo",
      "11": "Vasilevo",
      "13": "Veles",
      "12": "Vevčani",
      "14": "Vinica",
      "16": "Vrapčište",
      "32": "Zelenikovo",
      "33": "Zrnovci",
      "30": "Želino"
    },
    "callingCodes": ["389"],
    "ISO2digit": "MK",
    "ISO3digit": "MKD",
    "allowed": false
  },
  "MG": {
    "name": "Madagascar",
    "provinces": {
      "T": "Antananarivo",
      "D": "Antsiranana",
      "F": "Fianarantsoa",
      "M": "Mahajanga",
      "A": "Toamasina",
      "U": "Toliara"
    },
    "callingCodes": ["261"],
    "ISO2digit": "MG",
    "ISO3digit": "MDG",
    "allowed": true
  },
  "MW": {
    "name": "Malawi",
    "provinces": {
      "BA": "Balaka",
      "BL": "Blantyre",
      "CK": "Chikwawa",
      "CR": "Chiradzulu",
      "CT": "Chitipa",
      "DE": "Dedza",
      "DO": "Dowa",
      "KR": "Karonga",
      "KS": "Kasungu",
      "LK": "Likoma",
      "LI": "Lilongwe",
      "MH": "Machinga",
      "MG": "Mangochi",
      "MC": "Mchinji",
      "MU": "Mulanje",
      "MW": "Mwanza",
      "MZ": "Mzimba",
      "NE": "Neno",
      "NB": "Nkhata Bay",
      "NK": "Nkhotakota",
      "NS": "Nsanje",
      "NU": "Ntcheu",
      "NI": "Ntchisi",
      "PH": "Phalombe",
      "RU": "Rumphi",
      "SA": "Salima",
      "TH": "Thyolo",
      "ZO": "Zomba"
    },
    "callingCodes": ["265"],
    "ISO2digit": "MW",
    "ISO3digit": "MWI",
    "allowed": true
  },
  "MY": {
    "name": "Malaysia",
    "provinces": {
      "14": "Wilayah Persekutuan Kuala Lumpur",
      "15": "Wilayah Persekutuan Labuan",
      "16": "Wilayah Persekutuan Putrajaya",
      "01": "Johor",
      "02": "Kedah",
      "03": "Kelantan",
      "04": "Melaka",
      "05": "Negeri Sembilan",
      "06": "Pahang",
      "08": "Perak",
      "09": "Perlis",
      "07": "Pulau Pinang",
      "12": "Sabah",
      "13": "Sarawak",
      "10": "Selangor",
      "11": "Terengganu"
    },
    "callingCodes": ["60"],
    "ISO2digit": "MY",
    "ISO3digit": "MYS",
    "allowed": true
  },
  "MV": {
    "name": "Maldives",
    "provinces": {
      "MLE": "Maale",
      "CE": "Medhu",
      "NO": "Uthuru",
      "NC": "Medhu-Uthuru",
      "SU": "Dhekunu",
      "SC": "Medhu-Dhekunu",
      "UN": "Mathi-Uthuru",
      "US": "Mathi-Dhekunu"
    },
    "callingCodes": ["960"],
    "ISO2digit": "MV",
    "ISO3digit": "MDV",
    "allowed": true
  },
  "ML": {
    "name": "Mali",
    "provinces": {
      "BKO": "Bamako",
      "7": "Gao",
      "1": "Kayes",
      "8": "Kidal",
      "2": "Koulikoro",
      "5": "Mopti",
      "4": "Ségou",
      "3": "Sikasso",
      "6": "Tombouctou"
    },
    "callingCodes": ["223"],
    "ISO2digit": "ML",
    "ISO3digit": "MLI",
    "allowed": true
  },
  "MT": {
    "name": "Malta",
    "provinces": {
      "01": "Attard",
      "02": "Balzan",
      "03": "Birgu",
      "04": "Birkirkara",
      "05": "Birżebbuġa",
      "06": "Bormla",
      "07": "Dingli",
      "08": "Fgura",
      "09": "Floriana",
      "10": "Fontana",
      "11": "Gudja",
      "12": "Gżira",
      "13": "Għajnsielem",
      "14": "Għarb",
      "15": "Għargħur",
      "16": "Għasri",
      "17": "Għaxaq",
      "18": "Ħamrun",
      "19": "Iklin",
      "20": "Isla",
      "21": "Kalkara",
      "22": "Kerċem",
      "23": "Kirkop",
      "24": "Lija",
      "25": "Luqa",
      "26": "Marsa",
      "27": "Marsaskala",
      "28": "Marsaxlokk",
      "29": "Mdina",
      "30": "Mellieħa",
      "31": "Mġarr",
      "32": "Mosta",
      "33": "Mqabba",
      "34": "Msida",
      "35": "Mtarfa",
      "36": "Munxar",
      "37": "Nadur",
      "38": "Naxxar",
      "39": "Paola",
      "40": "Pembroke",
      "41": "Pietà",
      "42": "Qala",
      "43": "Qormi",
      "44": "Qrendi",
      "45": "Rabat Għawdex",
      "46": "Rabat Malta",
      "47": "Safi",
      "48": "San Ġiljan",
      "49": "San Ġwann",
      "50": "San Lawrenz",
      "51": "San Pawl il-Baħar",
      "52": "Sannat",
      "53": "Santa Luċija",
      "54": "Santa Venera",
      "55": "Siġġiewi",
      "56": "Sliema",
      "57": "Swieqi",
      "58": "Ta' Xbiex",
      "59": "Tarxien",
      "60": "Valletta",
      "61": "Xagħra",
      "62": "Xewkija",
      "63": "Xgħajra",
      "64": "Żabbar",
      "65": "Żebbuġ Għawdex",
      "66": "Żebbuġ Malta",
      "67": "Żejtun",
      "68": "Żurrieq"
    },
    "callingCodes": ["356"],
    "ISO2digit": "MT",
    "ISO3digit": "MLT",
    "allowed": true
  },
  "MH": {
    "name": "Marshall Islands",
    "provinces": {
      "ALL": "Ailinglaplap",
      "ALK": "Ailuk",
      "ARN": "Arno",
      "AUR": "Aur",
      "KIL": "Bikini and Kili",
      "EBO": "Ebon",
      "ENI": "Enewetak and Ujelang",
      "JAB": "Jabat",
      "JAL": "Jaluit",
      "KWA": "Kwajalein",
      "LAE": "Lae",
      "LIB": "Lib",
      "LIK": "Likiep",
      "MAJ": "Majuro",
      "MAL": "Maloelap",
      "MEJ": "Mejit",
      "MIL": "Mili",
      "NMK": "Namdrik",
      "NMU": "Namu",
      "RON": "Rongelap",
      "UJA": "Ujae",
      "UTI": "Utrik",
      "WTH": "Wotho",
      "WTJ": "Wotje"
    },
    "callingCodes": ["692"],
    "ISO2digit": "MH",
    "ISO3digit": "MHL",
    "allowed": true
  },
  "MQ": {
    "name": "Martinique",
    "provinces": [
      "Fort-de-France",
      "Marin",
      "Saint-Pierre",
      "Trinite"
    ],
    "callingCodes": ["596"],
    "ISO2digit": "MQ",
    "ISO3digit": "MTQ",
    "allowed": false
  },
  "MR": {
    "name": "Mauritania",
    "provinces": {
      "07": "Adrar",
      "03": "Assaba",
      "05": "Brakna",
      "08": "Dakhlet Nouâdhibou",
      "04": "Gorgol",
      "10": "Guidimaka",
      "01": "Hodh ech Chargui",
      "02": "Hodh el Gharbi",
      "12": "Inchiri",
      "14": "Nouakchott Nord",
      "13": "Nouakchott Ouest",
      "15": "Nouakchott Sud",
      "09": "Tagant",
      "11": "Tiris Zemmour",
      "06": "Trarza"
    },
    "callingCodes": ["222"],
    "ISO2digit": "MR",
    "ISO3digit": "MRT",
    "allowed": true
  },
  "MU": {
    "name": "Mauritius",
    "provinces": {
      "BR": "Beau Bassin-Rose Hill",
      "CU": "Curepipe",
      "PU": "Port Louis",
      "QB": "Quatre Bornes",
      "VP": "Vacoas-Phoenix",
      "AG": "Agalega Islands",
      "CC": "Cargados Carajos Shoals",
      "RO": "Rodrigues Island",
      "BL": "Black River",
      "FL": "Flacq",
      "GP": "Grand Port",
      "MO": "Moka",
      "PA": "Pamplemousses",
      "PW": "Plaines Wilhems",
      "PL": "Port Louis",
      "RR": "Rivière du Rempart",
      "SA": "Savanne"
    },
    "callingCodes": ["230"],
    "ISO2digit": "MU",
    "ISO3digit": "MUS",
    "allowed": true
  },
  "YT": {
    "name": "Mayotte",
    "provinces": [
      "Dzaoudzi",
      "Pamandzi",
      "Mamoudzou",
      "Dembeni",
      "Bandrélé",
      "Kani-Kéli",
      "Bouéni",
      "Chirongui",
      "Sada",
      "Ouangani",
      "Chiconi",
      "Tsingoni",
      "M'Tsangamouji",
      "Acoua",
      "Mtsamboro",
      "Bandraboua",
      "Koungou"
    ],
    "callingCodes": ["262"],
    "ISO2digit": "YT",
    "ISO3digit": "MYT",
    "allowed": false
  },
  "MX": {
    "name": "Mexico",
    "provinces": {
      "CMX": "México Distrito Federal",
      "AGU": "Aguascalientes",
      "BCN": "Baja California",
      "BCS": "Baja California Sur",
      "CAM": "Campeche",
      "COA": "Coahuila",
      "COL": "Colima",
      "CHP": "Chiapas",
      "CHH": "Chihuahua",
      "DUR": "Durango",
      "GUA": "Guanajuato",
      "GRO": "Guerrero",
      "HID": "Hidalgo",
      "JAL": "Jalisco",
      "MEX": "México",
      "MIC": "Michoacán",
      "MOR": "Morelos",
      "NAY": "Nayarit",
      "NLE": "Nuevo León",
      "OAX": "Oaxaca",
      "PUE": "Puebla",
      "QUE": "Querétaro",
      "ROO": "Quintana Roo",
      "SLP": "San Luis Potosí",
      "SIN": "Sinaloa",
      "SON": "Sonora",
      "TAB": "Tabasco",
      "TAM": "Tamaulipas",
      "TLA": "Tlaxcala",
      "VER": "Veracruz",
      "YUC": "Yucatán",
      "ZAC": "Zacatecas"
    },
    "callingCodes": ["52"],
    "ISO2digit": "MX",
    "ISO3digit": "MEX",
    "allowed": true
  },
  "FM": {
    "name": "Micronesia, Federated States of",
    "provinces": {
      "TRK": "Chuuk",
      "KSA": "Kosrae",
      "PNI": "Pohnpei",
      "YAP": "Yap"
    },
    "callingCodes": ["691"],
    "ISO2digit": "FM",
    "ISO3digit": "FSM",
    "allowed": true
  },
  "MD": {
    "name": "Moldova, Republic of",
    "provinces": {
      "GA": "Găgăuzia, Unitatea teritorială autonomă",
      "BA": "Bălți",
      "BD": "Bender [Tighina]",
      "CU": "Chișinău",
      "AN": "Anenii Noi",
      "BS": "Basarabeasca",
      "BR": "Briceni",
      "CA": "Cahul",
      "CT": "Cantemir",
      "CL": "Călărași",
      "CS": "Căușeni",
      "CM": "Cimișlia",
      "CR": "Criuleni",
      "DO": "Dondușeni",
      "DR": "Drochia",
      "DU": "Dubăsari",
      "ED": "Edineț",
      "FA": "Fălești",
      "FL": "Florești",
      "GL": "Glodeni",
      "HI": "Hîncești",
      "IA": "Ialoveni",
      "LE": "Leova",
      "NI": "Nisporeni",
      "OC": "Ocnița",
      "OR": "Orhei",
      "RE": "Rezina",
      "RI": "Rîșcani",
      "SI": "Sîngerei",
      "SO": "Soroca",
      "ST": "Strășeni",
      "SD": "Șoldănești",
      "SV": "Ștefan Vodă",
      "TA": "Taraclia",
      "TE": "Telenești",
      "UN": "Ungheni",
      "SN": "Stînga Nistrului, unitatea teritorială din"
    },
    "callingCodes": ["373"],
    "ISO2digit": "MD",
    "ISO3digit": "MDA",
    "allowed": true
  },
  "MC": {
    "name": "Monaco",
    "provinces": {
      "FO": "Fontvieille",
      "JE": "Jardin Exotique",
      "CL": "La Colle",
      "CO": "La Condamine",
      "GA": "La Gare",
      "SO": "La Source",
      "LA": "Larvotto",
      "MA": "Malbousquet",
      "MO": "Monaco-Ville",
      "MG": "Moneghetti",
      "MC": "Monte-Carlo",
      "MU": "Moulins",
      "PH": "Port-Hercule",
      "SR": "Saint-Roman",
      "SD": "Sainte-Dévote",
      "SP": "Spélugues",
      "VR": "Vallon de la Rousse"
    },
    "callingCodes": ["377"],
    "ISO2digit": "MC",
    "ISO3digit": "MCO",
    "allowed": true
  },
  "MN": {
    "name": "Mongolia",
    "provinces": {
      "073": "Arhangay",
      "069": "Bayanhongor",
      "071": "Bayan-Ölgiy",
      "067": "Bulgan",
      "037": "Darhan uul",
      "061": "Dornod",
      "063": "Dornogovĭ",
      "059": "Dundgovĭ",
      "057": "Dzavhan",
      "065": "Govĭ-Altay",
      "064": "Govĭ-Sümber",
      "039": "Hentiy",
      "043": "Hovd",
      "041": "Hövsgöl",
      "053": "Ömnögovĭ",
      "035": "Orhon",
      "055": "Övörhangay",
      "049": "Selenge",
      "051": "Sühbaatar",
      "047": "Töv",
      "1": "Ulaanbaatar",
      "046": "Uvs"
    },
    "callingCodes": ["976"],
    "ISO2digit": "MN",
    "ISO3digit": "MNG",
    "allowed": true
  },
  "ME": {
    "name": "Montenegro",
    "provinces": {
      "01": "Andrijevica",
      "02": "Bar",
      "03": "Berane",
      "04": "Bijelo Polje",
      "05": "Budva",
      "06": "Cetinje",
      "07": "Danilovgrad",
      "22": "Gusinje",
      "08": "Herceg-Novi",
      "09": "Kolašin",
      "10": "Kotor",
      "11": "Mojkovac",
      "12": "Nikšić",
      "23": "Petnjica",
      "13": "Plav",
      "14": "Pljevlja",
      "15": "Plužine",
      "16": "Podgorica",
      "17": "Rožaje",
      "18": "Šavnik",
      "19": "Tivat",
      "20": "Ulcinj",
      "21": "Žabljak"
    },
    "callingCodes": ["382"],
    "ISO2digit": "ME",
    "ISO3digit": "MNE",
    "allowed": false
  },
  "MS": {
    "name": "Open Sans",
    "provinces": [
      "Saint Peter",
      "Saint Anthony",
      "Saint Georges"
    ],
    "callingCodes": ["1664"],
    "ISO2digit": "MS",
    "ISO3digit": "MSR",
    "allowed": true
  },
  "MA": {
    "name": "Morocco",
    "provinces": {
      "09": "Chaouia-Ouardigha",
      "10": "Doukhala-Abda",
      "05": "Fès-Boulemane",
      "02": "Gharb-Chrarda-Beni Hssen",
      "08": "Grand Casablanca",
      "14": "Guelmim-Es Semara",
      "15": "Laâyoune-Boujdour-Sakia el Hamra",
      "11": "Marrakech-Tensift-Al Haouz",
      "06": "Meknès-Tafilalet",
      "04": "L'Oriental",
      "16": "Oued ed Dahab-Lagouira",
      "07": "Rabat-Salé-Zemmour-Zaer",
      "13": "Souss-Massa-Drâa",
      "12": "Tadla-Azilal",
      "01": "Tanger-Tétouan",
      "03": "Taza-Al HoceiTaounate"
    },
    "callingCodes": ["212"],
    "ISO2digit": "MA",
    "ISO3digit": "MAR",
    "allowed": true
  },
  "MZ": {
    "name": "Mozambique",
    "provinces": {
      "P": "Cabo Delgado",
      "G": "Gaza",
      "I": "Inhambane",
      "B": "Manica",
      "MPM": "Maputo",
      "L": "Maputo",
      "N": "Nampula",
      "A": "Niassa",
      "S": "Sofala",
      "T": "Tete",
      "Q": "Zambézia"
    },
    "callingCodes": ["258"],
    "ISO2digit": "MZ",
    "ISO3digit": "MOZ",
    "allowed": true
  },
  "MM": {
    "name": "Myanmar",
    "provinces": {
      "07": "Ayeyawady",
      "02": "Bago",
      "14": "Chin",
      "11": "Kachin",
      "12": "Kayah",
      "13": "Kayin",
      "03": "Magway",
      "04": "Mandalay",
      "15": "Mon",
      "18": "Nay Pyi Taw",
      "16": "Rakhine",
      "01": "Sagaing",
      "17": "Shan",
      "05": "Taninthayi",
      "06": "Yangon"
    },
    "callingCodes": ["95"],
    "ISO2digit": "MM",
    "ISO3digit": "MMR",
    "allowed": false
  },
  "NA": {
    "name": "Namibia",
    "provinces": {
      "ER": "Erongo",
      "HA": "Hardap",
      "KA": "Karas",
      "KE": "Kavango East",
      "KW": "Kavango West",
      "KH": "Khomas",
      "KU": "Kunene",
      "OW": "Ohangwena",
      "OH": "Omaheke",
      "OS": "Omusati",
      "ON": "Oshana",
      "OT": "Oshikoto",
      "OD": "Otjozondjupa",
      "CA": "Zambezi"
    },
    "callingCodes": ["264"],
    "ISO2digit": "NA",
    "ISO3digit": "NAM",
    "allowed": true
  },
  "NR": {
    "name": "Nauru",
    "provinces": {
      "01": "Aiwo",
      "02": "Anabar",
      "03": "Anetan",
      "04": "Anibare",
      "05": "Baiti",
      "06": "Boe",
      "07": "Buada",
      "08": "Denigomodu",
      "09": "Ewa",
      "10": "Ijuw",
      "11": "Meneng",
      "12": "Nibok",
      "13": "Uaboe",
      "14": "Yaren"
    },
    "callingCodes": ["674"],
    "ISO2digit": "NR",
    "ISO3digit": "NRU",
    "allowed": true
  },
  "NP": {
    "name": "Nepal",
    "provinces": {
      "BA": "Bagmati",
      "BH": "Bheri",
      "DH": "Dhawalagiri",
      "GA": "Gandaki",
      "JA": "Janakpur",
      "KA": "Karnali",
      "KO": "Kosi [Koshi]",
      "LU": "Lumbini",
      "MA": "Mahakali",
      "ME": "Mechi",
      "NA": "Narayani",
      "RA": "Rapti",
      "SA": "Sagarmatha",
      "SE": "Seti"
    },
    "callingCodes": ["977"],
    "ISO2digit": "NP",
    "ISO3digit": "NPL",
    "allowed": true
  },
  "NL": {
    "name": "Netherlands",
    "provinces": {
      "DR": "Drenthe",
      "FL": "Flevoland",
      "FR": "Fryslân",
      "GE": "Gelderland",
      "GR": "Groningen",
      "LI": "Limburg",
      "NB": "Noord-Brabant",
      "NH": "Noord-Holland",
      "OV": "Overijssel",
      "UT": "Utrecht",
      "ZE": "Zeeland",
      "ZH": "Zuid-Holland"
    },
    "callingCodes": ["31"],
    "ISO2digit": "NL",
    "ISO3digit": "NLD",
    "allowed": true
  },
  "NC": {
    "name": "New Caledonia",
    "provinces": [
      "Iles Loyaute",
      "Nord",
      "Sud"
    ],
    "callingCodes": ["687"],
    "ISO2digit": "NC",
    "ISO3digit": "NCL",
    "allowed": true
  },
  "NZ": {
    "name": "New Zealand",
    "provinces": {
      "AUK": "Auckland",
      "BOP": "Bay of Plenty",
      "CAN": "Canterbury",
      "CIT": "Chatham Islands Territory",
      "GIS": "Gisborne",
      "HKB": "Hawke's Bay",
      "MWT": "Manawatu-Wanganui",
      "MBH": "Marlborough",
      "NSN": "Nelson",
      "NTL": "Northland",
      "OTA": "Otago",
      "STL": "Southland",
      "TKI": "Taranaki",
      "TAS": "Tasman",
      "WKO": "Waikato",
      "WGN": "Wellington",
      "WTC": "West Coast"
    },
    "callingCodes": ["64"],
    "ISO2digit": "NZ",
    "ISO3digit": "NZL",
    "allowed": true
  },
  "NI": {
    "name": "Nicaragua",
    "provinces": {
      "AN": "Atlántico Norte",
      "AS": "Atlántico Sur",
      "BO": "Boaco",
      "CA": "Carazo",
      "CI": "Chinandega",
      "CO": "Chontales",
      "ES": "Estelí",
      "GR": "Granada",
      "JI": "Jinotega",
      "LE": "León",
      "MD": "Madriz",
      "MN": "Managua",
      "MS": "Masaya",
      "MT": "Matagalpa",
      "NS": "Nueva Segovia",
      "RI": "Rivas",
      "SJ": "Río San Juan"
    },
    "callingCodes": ["505"],
    "ISO2digit": "NI",
    "ISO3digit": "NIC",
    "allowed": true
  },
  "NE": {
    "name": "Niger",
    "provinces": {
      "1": "Agadez",
      "2": "Diffa",
      "3": "Dosso",
      "4": "Maradi",
      "8": "Niamey",
      "5": "Tahoua",
      "6": "Tillabéri",
      "7": "Zinder"
    },
    "callingCodes": ["227"],
    "ISO2digit": "NE",
    "ISO3digit": "NER",
    "allowed": true
  },
  "NG": {
    "name": "Nigeria",
    "provinces": {
      "AB": "Abia",
      "FC": "Abuja Federal Capital Territory",
      "AD": "Adamawa",
      "AK": "Akwa Ibom",
      "AN": "Anambra",
      "BA": "Bauchi",
      "BY": "Bayelsa",
      "BE": "Benue",
      "BO": "Borno",
      "CR": "Cross River",
      "DE": "Delta",
      "EB": "Ebonyi",
      "ED": "Edo",
      "EK": "Ekiti",
      "EN": "Enugu",
      "GO": "Gombe",
      "IM": "Imo",
      "JI": "Jigawa",
      "KD": "Kaduna",
      "KN": "Kano",
      "KT": "Katsina",
      "KE": "Kebbi",
      "KO": "Kogi",
      "KW": "Kwara",
      "LA": "Lagos",
      "NA": "Nasarawa",
      "NI": "Niger",
      "OG": "Ogun",
      "ON": "Ondo",
      "OS": "Osun",
      "OY": "Oyo",
      "PL": "Plateau",
      "RI": "Rivers",
      "SO": "Sokoto",
      "TA": "Taraba",
      "YO": "Yobe",
      "ZA": "Zamfara"
    },
    "callingCodes": ["234"],
    "ISO2digit": "NG",
    "ISO3digit": "NGA",
    "allowed": true
  },
  "NU": {
    "name": "Niue",
    "provinces": ["Niue"],
    "callingCodes": ["683"],
    "ISO2digit": "NU",
    "ISO3digit": "NIU",
    "allowed": true
  },
  "NF": {
    "name": "Norfolk Island",
    "provinces": ["Norfolk Island"],
    "callingCodes": ["672"],
    "ISO2digit": "NF",
    "ISO3digit": "NFK",
    "allowed": true
  },
  "MP": {
    "name": "Northern Mariana Islands",
    "provinces": [
      "Rota",
      "Saipan",
      "Tinian"
    ],
    "callingCodes": ["1670"],
    "ISO2digit": "MP",
    "ISO3digit": "MNP",
    "allowed": true
  },
  "NO": {
    "name": "Norway",
    "provinces": {
      "02": "Akershus",
      "09": "Aust-Agder",
      "06": "Buskerud",
      "20": "Finnmark",
      "04": "Hedmark",
      "12": "Hordaland",
      "22": "Jan Mayen",
      "15": "Møre og Romsdal",
      "18": "Nordland",
      "17": "Nord-Trøndelag",
      "05": "Oppland",
      "03": "Oslo",
      "11": "Rogaland",
      "14": "Sogn og Fjordane",
      "21": "Svalbard",
      "16": "Sør-Trøndelag",
      "08": "Telemark",
      "19": "Troms",
      "10": "Vest-Agder",
      "07": "Vestfold",
      "01": "Østfold"
    },
    "callingCodes": ["47"],
    "ISO2digit": "NO",
    "ISO3digit": "NOR",
    "allowed": true
  },
  "OM": {
    "name": "Oman",
    "provinces": {
      "DA": "Ad Dākhilīyah",
      "BU": "Al Buraymī",
      "WU": "Al Wusţá",
      "ZA": "Az̧ Z̧āhirah",
      "BJ": "Janūb al Bāţinah",
      "SJ": "Janūb ash Sharqīyah",
      "MA": "Masqaţ",
      "MU": "Musandam",
      "BS": "Shamāl al Bāţinah",
      "SS": "Shamāl ash Sharqīyah",
      "ZU": "Z̧ufār"
    },
    "callingCodes": ["968"],
    "ISO2digit": "OM",
    "ISO3digit": "OMN",
    "allowed": true
  },
  "PK": {
    "name": "Pakistan",
    "provinces": {
      "JK": "Azad Kashmir",
      "BA": "Balochistan",
      "TA": "Federally Administered Tribal Areas",
      "GB": "Gilgit-Baltistan",
      "IS": "Islamabad",
      "KP": "Khyber Pakhtunkhwa",
      "PB": "Punjab",
      "SD": "Sindh"
    },
    "callingCodes": ["92"],
    "ISO2digit": "PK",
    "ISO3digit": "PAK",
    "allowed": false
  },
  "PW": {
    "name": "Palau",
    "provinces": {
      "002": "Aimeliik",
      "004": "Airai",
      "010": "Angaur",
      "050": "Hatobohei",
      "100": "Kayangel",
      "150": "Koror",
      "212": "Melekeok",
      "214": "Ngaraard",
      "218": "Ngarchelong",
      "222": "Ngardmau",
      "224": "Ngatpang",
      "226": "Ngchesar",
      "227": "Ngeremlengui",
      "228": "Ngiwal",
      "350": "Peleliu",
      "370": "Sonsorol"
    },
    "callingCodes": ["680"],
    "ISO2digit": "PW",
    "ISO3digit": "PLW",
    "allowed": true
  },
  "PS": {
    "name": "Palestine",
    "provinces": {
      "GZZ": "Gaza Strip",
      "WBK": "West Bank"
    },
    "callingCodes": ["970"],
    "ISO2digit": "PS",
    "ISO3digit": "PSE",
    "allowed": true
  },
  "PA": {
    "name": "Panama",
    "provinces": {
      "1": "Bocas del Toro",
      "4": "Chiriquí",
      "2": "Coclé",
      "3": "Colón",
      "5": "Darién",
      "6": "Herrera",
      "7": "Los Santos",
      "8": "Panamá",
      "10": "Panamá Oeste",
      "9": "Veraguas"
    },
    "callingCodes": ["507"],
    "ISO2digit": "PA",
    "ISO3digit": "PAN",
    "allowed": true
  },
  "PG": {
    "name": "Papua New Guinea",
    "provinces": {
      "NSB": "Bougainville",
      "CPM": "Central",
      "CPK": "Chimbu",
      "EBR": "East New Britain",
      "ESW": "East Sepik",
      "EHG": "Eastern Highlands",
      "EPW": "Enga",
      "GPK": "Gulf",
      "HLA": "Hela",
      "JWK": "Jiwaka",
      "MPM": "Madang",
      "MRL": "Manus",
      "MBA": "Milne Bay",
      "MPL": "Morobe",
      "NCD": "National Capital District (Port Moresby)",
      "NIK": "New Ireland",
      "NPP": "Northern",
      "SHM": "Southern Highlands",
      "WBK": "West New Britain",
      "SAN": "West Sepik",
      "WPD": "Western",
      "WHM": "Western Highlands"
    },
    "callingCodes": ["675"],
    "ISO2digit": "PG",
    "ISO3digit": "PNG",
    "allowed": true
  },
  "PY": {
    "name": "Paraguay",
    "provinces": {
      "ASU": "Asunción",
      "11": "Central",
      "16": "Alto Paraguay",
      "10": "Alto Paraná",
      "13": "Amambay",
      "19": "Boquerón",
      "5": "Caaguazú",
      "6": "Caazapá",
      "14": "Canindeyú",
      "1": "Concepción",
      "3": "Cordillera",
      "4": "Guairá",
      "7": "Itapúa",
      "8": "Misiones",
      "9": "Paraguarí",
      "15": "Presidente Hayes",
      "2": "San Pedro",
      "12": "Ñeembucú"
    },
    "callingCodes": ["595"],
    "ISO2digit": "PY",
    "ISO3digit": "PRY",
    "allowed": true
  },
  "PE": {
    "name": "Peru",
    "provinces": {
      "AMA": "Amazonas",
      "ANC": "Ancash",
      "APU": "Apurímac",
      "ARE": "Arequipa",
      "AYA": "Ayacucho",
      "CAJ": "Cajamarca",
      "CUS": "Cusco",
      "CAL": "El Callao",
      "HUV": "Huancavelica",
      "HUC": "Huánuco",
      "ICA": "Ica",
      "JUN": "Junín",
      "LAL": "La Libertad",
      "LAM": "Lambayeque",
      "LIM": "Lima",
      "LOR": "Loreto",
      "MDD": "Madre de Dios",
      "MOQ": "Moquegua",
      "LMA": "Municipalidad Metropolitana de Lima",
      "PAS": "Pasco",
      "PIU": "Piura",
      "PUN": "Puno",
      "SAM": "San Martín",
      "TAC": "Tacna",
      "TUM": "Tumbes",
      "UCA": "Ucayali"
    },
    "callingCodes": ["51"],
    "ISO2digit": "PE",
    "ISO3digit": "PER",
    "allowed": true
  },
  "PH": {
    "name": "Philippines",
    "provinces": {
      "ABR": "Abra",
      "AGN": "Agusan del Norte",
      "AGS": "Agusan del Sur",
      "AKL": "Aklan",
      "ALB": "Albay",
      "ANT": "Antique",
      "APA": "Apayao",
      "AUR": "Aurora",
      "BAS": "Basilan",
      "BAN": "Bataan",
      "BTN": "Batanes",
      "BTG": "Batangas",
      "BEN": "Benguet",
      "BIL": "Biliran",
      "BOH": "Bohol",
      "BUK": "Bukidnon",
      "BUL": "Bulacan",
      "CAG": "Cagayan",
      "CAN": "Camarines Norte",
      "CAS": "Camarines Sur",
      "CAM": "Camiguin",
      "CAP": "Capiz",
      "CAT": "Catanduanes",
      "CAV": "Cavite",
      "CEB": "Cebu",
      "COM": "Compostela Valley",
      "NCO": "Cotabato",
      "DAV": "Davao del Norte",
      "DAS": "Davao del Sur",
      "DVO": "Davao Occidental",
      "DAO": "Davao Oriental",
      "DIN": "Dinagat Islands",
      "EAS": "Eastern Samar",
      "GUI": "Guimaras",
      "IFU": "Ifugao",
      "ILN": "Ilocos Norte",
      "ILS": "Ilocos Sur",
      "ILI": "Iloilo",
      "ISA": "Isabela",
      "KAL": "Kalinga",
      "LUN": "La Union",
      "LAG": "Laguna",
      "LAN": "Lanao del Norte",
      "LAS": "Lanao del Sur",
      "LEY": "Leyte",
      "MAG": "Maguindanao",
      "MAD": "Marinduque",
      "MAS": "Masbate",
      "MDC": "Mindoro Occidental",
      "MDR": "Mindoro Oriental",
      "MSC": "Misamis Occidental",
      "MSR": "Misamis Oriental",
      "MOU": "Mountain Province",
      "NEC": "Negros Occidental",
      "NER": "Negros Oriental",
      "NSA": "Northern Samar",
      "NUE": "Nueva Ecija",
      "NUV": "Nueva Vizcaya",
      "PLW": "Palawan",
      "PAM": "Pampanga",
      "PAN": "Pangasinan",
      "QUE": "Quezon",
      "QUI": "Quirino",
      "RIZ": "Rizal",
      "ROM": "Romblon",
      "WSA": "Samar",
      "SAR": "Sarangani",
      "SIG": "Siquijor",
      "SOR": "Sorsogon",
      "SCO": "South Cotabato",
      "SLE": "Southern Leyte",
      "SUK": "Sultan Kudarat",
      "SLU": "Sulu",
      "SUN": "Surigao del Norte",
      "SUR": "Surigao del Sur",
      "TAR": "Tarlac",
      "TAW": "Tawi-Tawi",
      "ZMB": "Zambales",
      "ZAN": "Zamboanga del Norte",
      "ZAS": "Zamboanga del Sur",
      "ZSI": "Zamboanga Sibugay"
    },
    "callingCodes": ["63"],
    "ISO2digit": "PH",
    "ISO3digit": "PHL",
    "allowed": true
  },
  "PN": {
    "name": "Pitcairn",
    "provinces": ["Pitcairn"],
    "callingCodes": ["64"],
    "ISO2digit": "PN",
    "ISO3digit": "PCN",
    "allowed": true
  },
  "PL": {
    "name": "Poland",
    "provinces": {
      "DS": "Dolnośląskie",
      "KP": "Kujawsko-pomorskie",
      "LU": "Lubelskie",
      "LB": "Lubuskie",
      "LD": "Łódzkie",
      "MA": "Małopolskie",
      "MZ": "Mazowieckie",
      "OP": "Opolskie",
      "PK": "Podkarpackie",
      "PD": "Podlaskie",
      "PM": "Pomorskie",
      "SL": "Śląskie",
      "SK": "Świętokrzyskie",
      "WN": "Warmińsko-mazurskie",
      "WP": "Wielkopolskie",
      "ZP": "Zachodniopomorskie"
    },
    "callingCodes": ["48"],
    "ISO2digit": "PL",
    "ISO3digit": "POL",
    "allowed": true
  },
  "PT": {
    "name": "Portugal",
    "provinces": {
      "01": "Aveiro",
      "02": "Beja",
      "03": "Braga",
      "04": "Bragança",
      "05": "Castelo Branco",
      "06": "Coimbra",
      "07": "Évora",
      "08": "Faro",
      "09": "Guarda",
      "10": "Leiria",
      "11": "Lisboa",
      "12": "Portalegre",
      "13": "Porto",
      "30": "Região Autónoma da Madeira",
      "20": "Região Autónoma dos Açores",
      "14": "Santarém",
      "15": "Setúbal",
      "16": "Viana do Castelo",
      "17": "Vila Real",
      "18": "Viseu"
    },
    "callingCodes": ["351"],
    "ISO2digit": "PT",
    "ISO3digit": "PRT",
    "allowed": true
  },
  "PR": {
    "name": "Puerto Rico",
    "provinces": [
      "Adjuntas",
      "Aguada",
      "Aguadilla",
      "Aguas Buenas",
      "Aibonito",
      "Arecibo",
      "Arroyo",
      "Añasco",
      "Barceloneta",
      "Barranquitas",
      "Bayamón",
      "Cabo Rojo",
      "Caguas",
      "Camuy",
      "Canóvanas",
      "Carolina",
      "Cataño",
      "Cayey",
      "Ceiba",
      "Ciales",
      "Cidra",
      "Coamo",
      "Comerío",
      "Corozal",
      "Culebra",
      "Dorado",
      "Fajardo",
      "Florida",
      "Guayama",
      "Guayanilla",
      "Guaynabo",
      "Gurabo",
      "Guánica",
      "Hatillo",
      "Hormigueros",
      "Humacao",
      "Isabela",
      "Jayuya",
      "Juana Díaz",
      "Juncos",
      "Lajas",
      "Lares",
      "Las Marías",
      "Las Piedras",
      "Loíza",
      "Luquillo",
      "Manatí",
      "Maricao",
      "Maunabo",
      "Mayagüez",
      "Moca",
      "Morovis",
      "Naguabo",
      "Naranjito",
      "Orocovis",
      "Patillas",
      "Peñuelas",
      "Ponce",
      "Quebradillas",
      "Rincón",
      "Río Grande",
      "Sabana Grande",
      "Salinas",
      "San Germán",
      "San Juan",
      "San Lorenzo",
      "San Sebastián",
      "Santa Isabel",
      "Toa Alta",
      "Toa Baja",
      "Trujillo Alto",
      "Utuado",
      "Vega Alta",
      "Vega Baja",
      "Vieques",
      "Villalba",
      "Yabucoa",
      "Yauco"
    ],
    "callingCodes": ["1787", "1939"],
    "ISO2digit": "PR",
    "ISO3digit": "PRI",
    "allowed": true
  },
  "QA": {
    "name": "Qatar",
    "provinces": {
      "DA": "Ad Dawḩah",
      "KH": "Al Khawr wa adh Dhakhīrah",
      "WA": "Al Wakrah",
      "RA": "Ar Rayyān",
      "MS": "Ash Shamāl",
      "ZA": "Az̧ Za̧`āyin",
      "US": "Umm Şalāl"
    },
    "callingCodes": ["974"],
    "ISO2digit": "QA",
    "ISO3digit": "QAT",
    "allowed": true
  },
  "RE": {
    "name": "Reunion",
    "provinces": [
      "Saint-Denis",
      "Saint-Benoît",
      "Saint-Paul",
      "Saint-Pierre"
    ],
    "callingCodes": ["262"],
    "ISO2digit": "RE",
    "ISO3digit": "REU",
    "allowed": false
  },
  "RO": {
    "name": "Romania",
    "provinces": {
      "AB": "Alba",
      "AR": "Arad",
      "AG": "Argeș",
      "BC": "Bacău",
      "BH": "Bihor",
      "BN": "Bistrița-Năsăud",
      "BT": "Botoșani",
      "BV": "Brașov",
      "BR": "Brăila",
      "B": "București",
      "BZ": "Buzău",
      "CS": "Caraș-Severin",
      "CL": "Călărași",
      "CJ": "Cluj",
      "CT": "Constanța",
      "CV": "Covasna",
      "DB": "Dâmbovița",
      "DJ": "Dolj",
      "GL": "Galați",
      "GR": "Giurgiu",
      "GJ": "Gorj",
      "HR": "Harghita",
      "HD": "Hunedoara",
      "IL": "Ialomița",
      "IS": "Iași",
      "IF": "Ilfov",
      "MM": "Maramureș",
      "MH": "Mehedinți",
      "MS": "Mureș",
      "NT": "Neamț",
      "OT": "Olt",
      "PH": "Prahova",
      "SM": "Satu Mare",
      "SJ": "Sălaj",
      "SB": "Sibiu",
      "SV": "Suceava",
      "TR": "Teleorman",
      "TM": "Timiș",
      "TL": "Tulcea",
      "VS": "Vaslui",
      "VL": "Vâlcea",
      "VN": "Vrancea"
    },
    "callingCodes": ["40"],
    "ISO2digit": "RO",
    "ISO3digit": "ROU",
    "allowed": false
  },
  "RU": {
    "name": "Russian Federation",
    "provinces": {
      "AD": "Adygeya",
      "AL": "Altay",
      "BA": "Bashkortostan",
      "BU": "Buryatiya",
      "CE": "Chechenskaya",
      "CU": "Chuvashskaya",
      "DA": "Dagestan",
      "IN": "Ingushetiya",
      "KB": "Kabardino-Balkarskaya",
      "KL": "Kalmykiya",
      "KC": "Karachayevo-Cherkesskaya",
      "KR": "Kareliya",
      "KK": "Khakasiya",
      "KO": "Komi",
      "ME": "Mariy El",
      "MO": "Mordoviya",
      "SA": "Sakha",
      "SE": "Severnaya Osetiya-Alaniya",
      "TA": "Tatarstan",
      "TY": "Tyva",
      "UD": "Udmurtskaya"
    },
    "callingCodes": ["7"],
    "ISO2digit": "RU",
    "ISO3digit": "RUS",
    "allowed": true
  },
  "RW": {
    "name": "Rwanda",
    "provinces": {
      "01": "City of Kigali",
      "02": "Eastern",
      "03": "Northern",
      "05": "Southern",
      "04": "Western"
    },
    "callingCodes": ["250"],
    "ISO2digit": "RW",
    "ISO3digit": "RWA",
    "allowed": true
  },
  "BL": {
    "name": "Saint Barthelemy",
    "provinces": ["Saint Barthelemy"],
    "callingCodes": ["590"],
    "ISO2digit": "BL",
    "ISO3digit": "BLM",
    "allowed": false
  },
  "SH": {
    "name": "Saint Helena",
    "provinces": {
      "AC": "Ascension",
      "HL": "Saint Helena",
      "TA": "Tristan da Cunha"
    },
    "callingCodes": ["290"],
    "ISO2digit": "SH",
    "ISO3digit": "SHN",
    "allowed": true
  },
  "KN": {
    "name": "Saint Kitts and Nevis",
    "provinces": {
      "K": "Saint Kitts",
      "N": "Nevis"
    },
    "callingCodes": ["1869"],
    "ISO2digit": "KN",
    "ISO3digit": "KNA",
    "allowed": true
  },
  "LC": {
    "name": "Saint Lucia",
    "provinces": {
      "01": "Anse la Raye",
      "12": "Canaries",
      "02": "Castries",
      "03": "Choiseul",
      "05": "Dennery",
      "06": "Gros Islet",
      "07": "Laborie",
      "08": "Micoud",
      "10": "Soufrière",
      "11": "Vieux Fort"
    },
    "callingCodes": ["1758"],
    "ISO2digit": "LC",
    "ISO3digit": "LCA",
    "allowed": true
  },
  "MF": {
    "name": "Saint Martin",
    "provinces": ["Saint Martin"],
    "callingCodes": ["590"],
    "ISO2digit": "MF",
    "ISO3digit": "MAF",
    "allowed": false
  },
  "PM": {
    "name": "Saint Pierre and Miquelon",
    "provinces": ["Saint Pierre and Miquelon"],
    "callingCodes": ["508"],
    "ISO2digit": "PM",
    "ISO3digit": "SPM",
    "allowed": true
  },
  "VC": {
    "name": "Saint Vincent and the Grenadines",
    "provinces": {
      "01": "Charlotte",
      "06": "Grenadines",
      "02": "Saint Andrew",
      "03": "Saint David",
      "04": "Saint George",
      "05": "Saint Patrick"
    },
    "callingCodes": ["1784"],
    "ISO2digit": "VC",
    "ISO3digit": "VCT",
    "allowed": true
  },
  "WS": {
    "name": "Samoa",
    "provinces": {
      "AA": "A'ana",
      "AL": "Aiga-i-le-Tai",
      "AT": "Atua",
      "FA": "Fa'asaleleaga",
      "GE": "Gaga'emauga",
      "GI": "Gagaifomauga",
      "PA": "Palauli",
      "SA": "Satupa'itea",
      "TU": "Tuamasaga",
      "VF": "Va'a-o-Fonoti",
      "VS": "Vaisigano"
    },
    "callingCodes": ["685"],
    "ISO2digit": "WS",
    "ISO3digit": "WSM",
    "allowed": true
  },
  "SM": {
    "name": "San Marino",
    "provinces": {
      "01": "Acquaviva",
      "06": "Borgo Maggiore",
      "02": "Chiesanuova",
      "03": "Domagnano",
      "04": "Faetano",
      "05": "Fiorentino",
      "08": "Montegiardino",
      "07": "San Marino",
      "09": "Serravalle"
    },
    "callingCodes": ["378"],
    "ISO2digit": "SM",
    "ISO3digit": "SMR",
    "allowed": true
  },
  "ST": {
    "name": "Sao Tome and Principe",
    "provinces": {
      "P": "Príncipe",
      "S": "São Tomé"
    },
    "callingCodes": ["239"],
    "ISO2digit": "ST",
    "ISO3digit": "STP",
    "allowed": true
  },
  "SA": {
    "name": "Saudi Arabia",
    "provinces": {
      "11": "Al Bāḩah",
      "08": "Al Ḩudūd ash Shamālīyah",
      "12": "Al Jawf",
      "03": "Al Madīnah al Munawwarah",
      "05": "Al Qaşīm",
      "01": "Ar Riyāḑ",
      "04": "Ash Sharqīyah",
      "14": "'Asīr",
      "06": "Ḩā'il",
      "09": "Jāzān",
      "02": "Makkah al Mukarramah",
      "10": "Najrān",
      "07": "Tabūk"
    },
    "callingCodes": ["966"],
    "ISO2digit": "SA",
    "ISO3digit": "SAU",
    "allowed": true
  },
  "SN": {
    "name": "Senegal",
    "provinces": {
      "DK": "Dakar",
      "DB": "Diourbel",
      "FK": "Fatick",
      "KA": "Kaffrine",
      "KL": "Kaolack",
      "KE": "Kédougou",
      "KD": "Kolda",
      "LG": "Louga",
      "MT": "Matam",
      "SL": "Saint-Louis",
      "SE": "Sédhiou",
      "TC": "Tambacounda",
      "TH": "Thiès",
      "ZG": "Ziguinchor"
    },
    "callingCodes": ["221"],
    "ISO2digit": "SN",
    "ISO3digit": "SEN",
    "allowed": true
  },
  "RS": {
    "name": "Serbia",
    "provinces": {
      "KM": "Kosovo-Metohija",
      "VO": "Vojvodina"
    },
    "callingCodes": ["381"],
    "ISO2digit": "RS",
    "ISO3digit": "SRB",
    "allowed": false
  },
  "SC": {
    "name": "Seychelles",
    "provinces": {
      "01": "Anse aux Pins",
      "02": "Anse Boileau",
      "03": "Anse Etoile",
      "05": "Anse Royale",
      "04": "Au Cap",
      "06": "Baie Lazare",
      "07": "Baie Sainte Anne",
      "08": "Beau Vallon",
      "09": "Bel Air",
      "10": "Bel Ombre",
      "11": "Cascade",
      "16": "English River",
      "12": "Glacis",
      "13": "Grand Anse Mahe",
      "14": "Grand Anse Praslin",
      "15": "La Digue",
      "24": "Les Mamelles",
      "17": "Mont Buxton",
      "18": "Mont Fleuri",
      "19": "Plaisance",
      "20": "Pointe Larue",
      "21": "Port Glaud",
      "25": "Roche Caiman",
      "22": "Saint Louis",
      "23": "Takamaka"
    },
    "callingCodes": ["248"],
    "ISO2digit": "SC",
    "ISO3digit": "SYC",
    "allowed": true
  },
  "SL": {
    "name": "Sierra Leone",
    "provinces": {
      "E": "Eastern",
      "N": "Northern",
      "S": "Southern",
      "W": "Western Area"
    },
    "callingCodes": ["232"],
    "ISO2digit": "SL",
    "ISO3digit": "SLE",
    "allowed": true
  },
  "SG": {
    "name": "Singapore",
    "provinces": {
      "01": "Central Singapore",
      "02": "North East",
      "03": "North West",
      "04": "South East",
      "05": "South West"
    },
    "callingCodes": ["65"],
    "ISO2digit": "SG",
    "ISO3digit": "SGP",
    "allowed": true
  },
  "SX": {
    "name": "Sint Maarten",
    "provinces": ["Sint Maarten"],
    "callingCodes": ["1721"],
    "ISO2digit": "SX",
    "ISO3digit": "SXM",
    "allowed": false
  },
  "SK": {
    "name": "Slovakia",
    "provinces": {
      "BC": "Banskobystrický kraj",
      "BL": "Bratislavský kraj",
      "KI": "Košický kraj",
      "NI": "Nitriansky kraj",
      "PV": "Prešovský kraj",
      "TC": "Trenčiansky kraj",
      "TA": "Trnavský kraj",
      "ZI": "Žilinský kraj"
    },
    "callingCodes": ["421"],
    "ISO2digit": "SK",
    "ISO3digit": "SVK",
    "allowed": true
  },
  "SI": {
    "name": "Slovenia",
    "provinces": {
      "001": "Ajdovščina",
      "213": "Ankaran",
      "195": "Apače",
      "002": "Beltinci",
      "148": "Benedikt",
      "149": "Bistrica ob Sotli",
      "003": "Bled",
      "150": "Bloke",
      "004": "Bohinj",
      "005": "Borovnica",
      "006": "Bovec",
      "151": "Braslovče",
      "007": "Brda",
      "009": "Brežice",
      "008": "Brezovica",
      "152": "Cankova",
      "011": "Celje",
      "012": "Cerklje na Gorenjskem",
      "013": "Cerknica",
      "014": "Cerkno",
      "153": "Cerkvenjak",
      "196": "Cirkulane",
      "015": "Črenšovci",
      "016": "Črna na Koroškem",
      "017": "Črnomelj",
      "018": "Destrnik",
      "019": "Divača",
      "154": "Dobje",
      "020": "Dobrepolje",
      "155": "Dobrna",
      "021": "Dobrova–Polhov Gradec",
      "156": "Dobrovnik",
      "157": "Dolenjske Toplice",
      "022": "Dol pri Ljubljani",
      "023": "Domžale",
      "024": "Dornava",
      "025": "Dravograd",
      "026": "Duplek",
      "027": "Gorenja vas–Poljane",
      "028": "Gorišnica",
      "207": "Gorje",
      "029": "Gornja Radgona",
      "030": "Gornji Grad",
      "031": "Gornji Petrovci",
      "158": "Grad",
      "032": "Grosuplje",
      "159": "Hajdina",
      "160": "Hoče–Slivnica",
      "161": "Hodoš",
      "162": "Horjul",
      "034": "Hrastnik",
      "035": "Hrpelje-Kozina",
      "036": "Idrija",
      "037": "Ig",
      "038": "Ilirska Bistrica",
      "039": "Ivančna Gorica",
      "040": "Izola",
      "041": "Jesenice",
      "163": "Jezersko",
      "042": "Juršinci",
      "043": "Kamnik",
      "044": "Kanal",
      "045": "Kidričevo",
      "046": "Kobarid",
      "047": "Kobilje",
      "048": "Kočevje",
      "049": "Komen",
      "164": "Komenda",
      "050": "Koper",
      "197": "Kosanjevica na Krki",
      "165": "Kostel",
      "051": "Kozje",
      "052": "Kranj",
      "053": "Kranjska Gora",
      "166": "Križevci",
      "054": "Krško",
      "055": "Kungota",
      "056": "Kuzma",
      "057": "Laško",
      "058": "Lenart",
      "059": "Lendava",
      "060": "Litija",
      "061": "Ljubljana",
      "062": "Ljubno",
      "063": "Ljutomer",
      "064": "Logatec",
      "208": "Log-Dragomer",
      "065": "Loška Dolina",
      "066": "Loški Potok",
      "167": "Lovrenc na Pohorju",
      "067": "Luče",
      "068": "Lukovica",
      "069": "Majšperk",
      "198": "Makole",
      "070": "Maribor",
      "168": "Markovci",
      "071": "Medvode",
      "072": "Mengeš",
      "073": "Metlika",
      "074": "Mežica",
      "169": "Miklavž na Dravskem Polju",
      "075": "Miren-Kostanjevica",
      "212": "Mirna",
      "170": "Mirna Peč",
      "076": "Mislinja",
      "199": "Mokronog-Trebelno",
      "077": "Moravče",
      "078": "Moravske Toplice",
      "079": "Mozirje",
      "080": "Murska Sobota",
      "081": "Muta",
      "082": "Naklo",
      "083": "Nazarje",
      "084": "Nova Gorica",
      "085": "Novo Mesto",
      "086": "Odranci",
      "171": "Oplotnica",
      "087": "Ormož",
      "088": "Osilnica",
      "089": "Pesnica",
      "090": "Piran",
      "091": "Pivka",
      "092": "Podčetrtek",
      "172": "Podlehnik",
      "093": "Podvelka",
      "200": "Poljčane",
      "173": "Polzela",
      "094": "Postojna",
      "174": "Prebold",
      "095": "Preddvor",
      "175": "Prevalje",
      "096": "Ptuj",
      "097": "Puconci",
      "098": "Rače–Fram",
      "099": "Radeče",
      "100": "Radenci",
      "101": "Radlje ob Dravi",
      "102": "Radovljica",
      "103": "Ravne na Koroškem",
      "176": "Razkrižje",
      "209": "Rečica ob Savinji",
      "201": "Renče-Vogrsko",
      "104": "Ribnica",
      "177": "Ribnica na Pohorju",
      "106": "Rogaška Slatina",
      "105": "Rogašovci",
      "107": "Rogatec",
      "108": "Ruše",
      "178": "Selnica ob Dravi",
      "109": "Semič",
      "110": "Sevnica",
      "111": "Sežana",
      "112": "Slovenj Gradec",
      "113": "Slovenska Bistrica",
      "114": "Slovenske Konjice",
      "179": "Sodražica",
      "180": "Solčava",
      "202": "Središče ob Dravi",
      "115": "Starše",
      "203": "Straža",
      "181": "Sveta Ana",
      "204": "Sveta Trojica v Slovenskih Goricah",
      "182": "Sveti Andraž v Slovenskih Goricah",
      "116": "Sveti Jurij",
      "210": "Sveti Jurij v Slovenskih Goricah",
      "205": "Sveti Tomaž",
      "033": "Šalovci",
      "183": "Šempeter-Vrtojba",
      "117": "Šenčur",
      "118": "Šentilj",
      "119": "Šentjernej",
      "120": "Šentjur",
      "211": "Šentrupert",
      "121": "Škocjan",
      "122": "Škofja Loka",
      "123": "Škofljica",
      "124": "Šmarje pri Jelšah",
      "206": "Šmarješke Toplice",
      "125": "Šmartno ob Paki",
      "194": "Šmartno pri Litiji",
      "126": "Šoštanj",
      "127": "Štore",
      "184": "Tabor",
      "010": "Tišina",
      "128": "Tolmin",
      "129": "Trbovlje",
      "130": "Trebnje",
      "185": "Trnovska Vas",
      "186": "Trzin",
      "131": "Tržič",
      "132": "Turnišče",
      "133": "Velenje",
      "187": "Velika Polana",
      "134": "Velike Lašče",
      "188": "Veržej",
      "135": "Videm",
      "136": "Vipava",
      "137": "Vitanje",
      "138": "Vodice",
      "139": "Vojnik",
      "189": "Vransko",
      "140": "Vrhnika",
      "141": "Vuzenica",
      "142": "Zagorje ob Savi",
      "143": "Zavrč",
      "144": "Zreče",
      "190": "Žalec",
      "146": "Železniki",
      "191": "Žetale",
      "147": "Žiri",
      "192": "Žirovnica",
      "193": "Žužemberk"
    },
    "callingCodes": ["386"],
    "ISO2digit": "SI",
    "ISO3digit": "SVN",
    "allowed": true
  },
  "SB": {
    "name": "Solomon Islands",
    "provinces": {
      "CT": "Capital Territory",
      "CE": "Central",
      "CH": "Choiseul",
      "GU": "Guadalcanal",
      "IS": "Isabel",
      "MK": "Makira-Ulawa",
      "ML": "Malaita",
      "RB": "Rennell and Bellona",
      "TE": "Temotu",
      "WE": "Western"
    },
    "callingCodes": ["677"],
    "ISO2digit": "SB",
    "ISO3digit": "SLB",
    "allowed": true
  },
  "SO": {
    "name": "Somalia",
    "provinces": {
      "AW": "Awdal",
      "BK": "Bakool",
      "BN": "Banaadir",
      "BR": "Bari",
      "BY": "Bay",
      "GA": "Galguduud",
      "GE": "Gedo",
      "HI": "Hiiraan",
      "JD": "Jubbada Dhexe",
      "JH": "Jubbada Hoose",
      "MU": "Mudug",
      "NU": "Nugaal",
      "SA": "Sanaag",
      "SD": "Shabeellaha Dhexe",
      "SH": "Shabeellaha Hoose",
      "SO": "Sool",
      "TO": "Togdheer",
      "WO": "Woqooyi Galbeed"
    },
    "callingCodes": ["252"],
    "ISO2digit": "SO",
    "ISO3digit": "SOM",
    "allowed": true
  },
  "ZA": {
    "name": "South Africa",
    "provinces": {
      "EC": "Eastern Cape",
      "FS": "Free State",
      "GT": "Gauteng",
      "NL": "KwaZulu-Natal",
      "LP": "Limpopo",
      "MP": "Mpumalanga",
      "NC": "Northern Cape",
      "NW": "North West",
      "WC": "Western Cape"
    },
    "callingCodes": ["27"],
    "ISO2digit": "ZA",
    "ISO3digit": "ZAF",
    "allowed": true
  },
  "GS": {
    "name": "South Georgia and the South Sandwich Islands",
    "provinces": ["South Georgia and the South Sandwich Islands"],
    "callingCodes": ["500"],
    "ISO2digit": "GS",
    "ISO3digit": "SGS",
    "allowed": true
  },
  "SS": {
    "name": "South Sudan",
    "provinces": {
      "EC": "Central Equatoria",
      "EE": "Eastern Equatoria",
      "JG": "Jonglei",
      "LK": "Lakes",
      "BN": "Northern Bahr el Ghazal",
      "UY": "Unity",
      "NU": "Upper Nile",
      "WR": "Warrap",
      "BW": "Western Bahr el Ghazal",
      "EW": "Western Equatoria"
    },
    "callingCodes": ["211"],
    "ISO2digit": "SS",
    "ISO3digit": "SSD",
    "allowed": false
  },
  "ES": {
    "name": "Spain",
    "provinces": {
      "AN": "Andalucía",
      "AR": "Aragón",
      "AS": "Asturias, Principado de",
      "CN": "Canarias",
      "CB": "Cantabria",
      "CM": "Castilla-La Mancha",
      "CL": "Castilla y León",
      "CT": "Catalunya",
      "CE": "Ceuta",
      "EX": "Extremadura",
      "GA": "Galicia",
      "IB": "Illes Balears",
      "RI": "La Rioja",
      "MD": "Madrid, Comunidad de",
      "ML": "Melilla",
      "MC": "Murcia, Región de",
      "NC": "Navarra, Comunidad Foral de",
      "PV": "País Vasco",
      "VC": "Valenciana, Comunidad"
    },
    "callingCodes": ["34"],
    "ISO2digit": "ES",
    "ISO3digit": "ESP",
    "allowed": true
  },
  "LK": {
    "name": "Sri Lanka",
    "provinces": {
      "2": "Central",
      "5": "Eastern",
      "7": "North Central",
      "6": "North Western",
      "4": "Northern",
      "9": "Sabaragamuwa",
      "3": "Southern",
      "8": "Uva",
      "1": "Western"
    },
    "callingCodes": ["94"],
    "ISO2digit": "LK",
    "ISO3digit": "LKA",
    "allowed": true
  },
  "SD": {
    "name": "Sudan",
    "provinces": {
      "RS": "Al Baḩr al Aḩmar",
      "GZ": "Al Jazīrah",
      "KH": "Al Kharţūm",
      "GD": "Al Qaḑārif",
      "NW": "An Nīl al Abyaḑ",
      "NB": "An Nīl al Azraq",
      "NO": "Ash Shamālīyah",
      "DW": "Gharb Dārfūr",
      "GK": "Gharb Kurdufān",
      "DS": "Janūb Dārfūr",
      "KS": "Janūb Kurdufān",
      "KA": "Kassalā",
      "NR": "Nahr an Nīl",
      "DN": "Shamāl Dārfūr",
      "DE": "Sharq Dārfūr",
      "KN": "Shiamāl Kurdufān",
      "SI": "Sinnār",
      "DC": "Wasaţ Dārfūr Zālinjay"
    },
    "callingCodes": ["249"],
    "ISO2digit": "SD",
    "ISO3digit": "SDN",
    "allowed": true
  },
  "SR": {
    "name": "Suriname",
    "provinces": {
      "BR": "Brokopondo",
      "CM": "Commewijne",
      "CR": "Coronie",
      "MA": "Marowijne",
      "NI": "Nickerie",
      "PR": "Para",
      "PM": "Paramaribo",
      "SA": "Saramacca",
      "SI": "Sipaliwini",
      "WA": "Wanica"
    },
    "callingCodes": ["597"],
    "ISO2digit": "SR",
    "ISO3digit": "SUR",
    "allowed": true
  },
  "SJ": {
    "name": "Svalbard and Jan Mayen",
    "provinces": [
      "Jan Mayen",
      "Svalbard"
    ],
    "callingCodes": ["47"],
    "ISO2digit": "SJ",
    "ISO3digit": "SJM",
    "allowed": true
  },
  "SZ": {
    "name": "Swaziland",
    "provinces": {
      "HH": "Hhohho",
      "LU": "Lubombo",
      "MA": "Manzini",
      "SH": "Shiselweni"
    },
    "callingCodes": ["268"],
    "ISO2digit": "SZ",
    "ISO3digit": "SWZ",
    "allowed": true
  },
  "SE": {
    "name": "Sweden",
    "provinces": {
      "K": "Blekinge län",
      "W": "Dalarnas län",
      "I": "Gotlands län",
      "X": "Gävleborgs län",
      "N": "Hallands län",
      "Z": "Jämtlands län",
      "F": "Jönköpings län",
      "H": "Kalmar län",
      "G": "Kronobergs län",
      "BD": "Norrbottens län",
      "M": "Skåne län",
      "AB": "Stockholms län",
      "D": "Södermanlands län",
      "C": "Uppsala län",
      "S": "Värmlands län",
      "AC": "Västerbottens län",
      "Y": "Västernorrlands län",
      "U": "Västmanlands län",
      "O": "Västra Götalands län",
      "T": "Örebro län",
      "E": "Östergötlands län"
    },
    "callingCodes": ["46"],
    "ISO2digit": "SE",
    "ISO3digit": "SWE",
    "allowed": true
  },
  "CH": {
    "name": "Switzerland",
    "provinces": {
      "AG": "Aargau",
      "AR": "Appenzell Ausserrhoden",
      "AI": "Appenzell Innerrhoden",
      "BL": "Basel-Landschaft",
      "BS": "Basel-Stadt",
      "BE": "Bern",
      "FR": "Fribourg",
      "GE": "Genève",
      "GL": "Glarus",
      "GR": "Graubünden",
      "JU": "Jura",
      "LU": "Luzern",
      "NE": "Neuchâtel",
      "NW": "Nidwalden",
      "OW": "Obwalden",
      "SG": "Sankt Gallen",
      "SH": "Schaffhausen",
      "SZ": "Schwyz",
      "SO": "Solothurn",
      "TG": "Thurgau",
      "TI": "Ticino",
      "UR": "Uri",
      "VS": "Valais",
      "VD": "Vaud",
      "ZG": "Zug",
      "ZH": "Zürich"
    },
    "callingCodes": ["41"],
    "ISO2digit": "CH",
    "ISO3digit": "CHE",
    "allowed": true
  },
  "SY": {
    "name": "Syria",
    "provinces": {
      "HA": "Al Ḩasakah",
      "LA": "Al Lādhiqīyah",
      "QU": "Al Qunayţirah",
      "RA": "Ar Raqqah",
      "SU": "As Suwaydā'",
      "DR": "Dar'ā",
      "DY": "Dayr az Zawr",
      "DI": "Dimashq",
      "HL": "Ḩalab",
      "HM": "Ḩamāh",
      "HI": "Ḩimş",
      "ID": "Idlib",
      "RD": "Rīf Dimashq",
      "TA": "Ţarţūs"
    },
    "callingCodes": ["963"],
    "ISO2digit": "SY",
    "ISO3digit": "SYR",
    "allowed": true
  },
  "TW": {
    "name": "Taiwan",
    "provinces": {
      "CHA": "Changhua",
      "CYQ": "Chiayi",
      "HSQ": "Hsinchu",
      "HUA": "Hualien",
      "KIN": "Kinmen",
      "LIE": "Lienchiang",
      "MIA": "Miaoli",
      "NAN": "Nantou",
      "PEN": "Penghu",
      "PIF": "Pingtung",
      "TTT": "Taitung",
      "ILA": "Yilan",
      "YUN": "Yunlin"
    },
    "callingCodes": ["886"],
    "ISO2digit": "TW",
    "ISO3digit": "TWN",
    "allowed": true
  },
  "TJ": {
    "name": "Tajikistan",
    "provinces": {
      "DU": "Dushanbe",
      "KT": "Khatlon",
      "GB": "Kŭhistoni Badakhshon",
      "RA": "Nohiyahoi Tobei Jumhurí",
      "SU": "Sughd"
    },
    "callingCodes": ["992"],
    "ISO2digit": "TJ",
    "ISO3digit": "TJK",
    "allowed": true
  },
  "TZ": {
    "name": "Tanzania, United Republic of",
    "provinces": {
      "01": "Arusha",
      "02": "Dar es Salaam",
      "03": "Dodoma",
      "27": "Geita",
      "04": "Iringa",
      "05": "Kagera",
      "06": "Kaskazini Pemba",
      "07": "Kaskazini Unguja",
      "28": "Katavi",
      "08": "Kigoma",
      "09": "Kilimanjaro",
      "10": "Kusini Pemba",
      "11": "Kusini Unguja",
      "12": "Lindi",
      "26": "Manyara",
      "13": "Mara",
      "14": "Mbeya",
      "15": "Mjini Magharibi",
      "16": "Morogoro",
      "17": "Mtwara",
      "18": "Mwanza",
      "29": "Njombe",
      "19": "Pwani",
      "20": "Rukwa",
      "21": "Ruvuma",
      "22": "Shinyanga",
      "30": "Simiyu",
      "23": "Singida",
      "24": "Tabora",
      "25": "Tanga"
    },
    "callingCodes": ["255"],
    "ISO2digit": "TZ",
    "ISO3digit": "TZA",
    "allowed": true
  },
  "TH": {
    "name": "Thailand",
    "provinces": {
      "37": "Amnat Charoen",
      "15": "Ang Thong",
      "38": "Bueng Kan",
      "31": "Buriram",
      "24": "Chachoengsao",
      "18": "Chai Nat",
      "36": "Chaiyaphum",
      "22": "Chanthaburi",
      "50": "Chiang Mai",
      "57": "Chiang Rai",
      "20": "Chon Buri",
      "86": "Chumphon",
      "46": "Kalasin",
      "62": "Kamphaeng Phet",
      "71": "Kanchanaburi",
      "40": "Khon Kaen",
      "81": "Krabi",
      "10": "Krung Thep Maha Nakhon",
      "52": "Lampang",
      "51": "Lamphun",
      "42": "Loei",
      "16": "Lopburi",
      "58": "Mae Hong Son",
      "44": "Maha Sarakham",
      "49": "Mukdahan",
      "26": "Nakhon Nayok",
      "73": "Nakhon Pathom",
      "48": "Nakhon Phanom",
      "30": "Nakhon Ratchasima",
      "60": "Nakhon Sawan",
      "80": "Nakhon Si Thammarat",
      "55": "Nan",
      "96": "Narathiwat",
      "39": "Nong Bua Lam Phu",
      "43": "Nong Khai",
      "12": "Nonthaburi",
      "13": "Pathum Thani",
      "94": "Pattani",
      "S": "Pattaya",
      "82": "Phangnga",
      "93": "Phatthalung",
      "56": "Phayao",
      "67": "Phetchabun",
      "76": "Phetchaburi",
      "66": "Phichit",
      "65": "Phitsanulok",
      "54": "Phrae",
      "14": "Phra Nakhon Si Ayutthaya",
      "83": "Phuket",
      "25": "Prachin Buri",
      "77": "Prachuap Khiri Khan",
      "85": "Ranong",
      "70": "Ratchaburi",
      "21": "Rayong",
      "45": "Roi Et",
      "27": "Sa Kaeo",
      "47": "Sakon Nakhon",
      "11": "Samut Prakan",
      "74": "Samut Sakhon",
      "75": "Samut Songkhram",
      "19": "Saraburi",
      "91": "Satun",
      "17": "Sing Buri",
      "33": "Sisaket",
      "90": "Songkhla",
      "64": "Sukhothai",
      "72": "Suphan Buri",
      "84": "Surat Thani",
      "32": "Surin",
      "63": "Tak",
      "92": "Trang",
      "23": "Trat",
      "34": "Ubon Ratchathani",
      "41": "Udon Thani",
      "61": "Uthai Thani",
      "53": "Uttaradit",
      "95": "Yala",
      "35": "Yasothon"
    },
    "callingCodes": ["66"],
    "ISO2digit": "TH",
    "ISO3digit": "THA",
    "allowed": true
  },
  "TL": {
    "name": "Timor-Leste",
    "provinces": {
      "AL": "Aileu",
      "AN": "Ainaro",
      "BA": "Baucau",
      "BO": "Bobonaro",
      "CO": "Cova Lima",
      "DI": "Díli",
      "ER": "Ermera",
      "LA": "Lautem",
      "LI": "Liquiça",
      "MT": "Manatuto",
      "MF": "Manufahi",
      "OE": "Oecussi",
      "VI": "Viqueque"
    },
    "callingCodes": ["670"],
    "ISO2digit": "TL",
    "ISO3digit": "TLS",
    "allowed": true
  },
  "TG": {
    "name": "Togo",
    "provinces": {
      "C": "Centre",
      "K": "Kara",
      "M": "Maritime",
      "P": "Plateaux",
      "S": "Savannes"
    },
    "callingCodes": ["228"],
    "ISO2digit": "TG",
    "ISO3digit": "TGO",
    "allowed": true
  },
  "TK": {
    "name": "Tokelau",
    "provinces": [
      "Atafu",
      "Nukunonu",
      "Fakaofo"
    ],
    "callingCodes": ["690"],
    "ISO2digit": "TK",
    "ISO3digit": "TKL",
    "allowed": true
  },
  "TO": {
    "name": "Tonga",
    "provinces": {
      "01": "'Eua",
      "02": "Ha'apai",
      "03": "Niuas",
      "04": "Tongatapu",
      "05": "Vava'u"
    },
    "callingCodes": ["676"],
    "ISO2digit": "TO",
    "ISO3digit": "TON",
    "allowed": true
  },
  "TT": {
    "name": "Trinidad and Tobago",
    "provinces": {
      "ARI": "Arima",
      "CHA": "Chaguanas",
      "CTT": "Couva-Tabaquite-Talparo",
      "DMN": "Diego Martin",
      "MRC": "Mayaro-Rio Claro",
      "PED": "Penal-Debe",
      "PTF": "Point Fortin",
      "POS": "Port of Spain",
      "PRT": "Princes Town",
      "SFO": "San Fernando",
      "SJL": "San Juan-Laventille",
      "SGE": "Sangre Grande",
      "SIP": "Siparia",
      "TOB": "Tobago",
      "TUP": "Tunapuna-Piarco"
    },
    "callingCodes": ["1868"],
    "ISO2digit": "TT",
    "ISO3digit": "TTO",
    "allowed": true
  },
  "TN": {
    "name": "Tunisia",
    "provinces": {
      "31": "Béja",
      "13": "Ben Arous",
      "23": "Bizerte",
      "81": "Gabès",
      "71": "Gafsa",
      "32": "Jendouba",
      "41": "Kairouan",
      "42": "Kasserine",
      "73": "Kébili",
      "12": "L'Ariana",
      "14": "La Manouba",
      "33": "Le Kef",
      "53": "Mahdia",
      "52": "Monastir",
      "82": "Médenine",
      "21": "Nabeul",
      "61": "Sfax",
      "43": "Sidi Bouzid",
      "34": "Siliana",
      "51": "Sousse",
      "83": "Tataouine",
      "72": "Tozeur",
      "11": "Tunis",
      "22": "Zaghouan"
    },
    "callingCodes": ["216"],
    "ISO2digit": "TN",
    "ISO3digit": "TUN",
    "allowed": true
  },
  "TR": {
    "name": "Turkey",
    "provinces": {
      "01": "Adana",
      "02": "Adıyaman",
      "03": "Afyonkarahisar",
      "04": "Ağrı",
      "68": "Aksaray",
      "05": "Amasya",
      "06": "Ankara",
      "07": "Antalya",
      "75": "Ardahan",
      "08": "Artvin",
      "09": "Aydın",
      "10": "Balıkesir",
      "74": "Bartın",
      "72": "Batman",
      "69": "Bayburt",
      "11": "Bilecik",
      "12": "Bingöl",
      "13": "Bitlis",
      "14": "Bolu",
      "15": "Burdur",
      "16": "Bursa",
      "17": "Çanakkale",
      "18": "Çankırı",
      "19": "Çorum",
      "20": "Denizli",
      "21": "Diyarbakır",
      "81": "Düzce",
      "22": "Edirne",
      "23": "Elazığ",
      "24": "Erzincan",
      "25": "Erzurum",
      "26": "Eskişehir",
      "27": "Gaziantep",
      "28": "Giresun",
      "29": "Gümüşhane",
      "30": "Hakkâri",
      "31": "Hatay",
      "76": "Iğdır",
      "32": "Isparta",
      "34": "İstanbul",
      "35": "İzmir",
      "46": "Kahramanmaraş",
      "78": "Karabük",
      "70": "Karaman",
      "36": "Kars",
      "37": "Kastamonu",
      "38": "Kayseri",
      "71": "Kırıkkale",
      "39": "Kırklareli",
      "40": "Kırşehir",
      "79": "Kilis",
      "41": "Kocaeli",
      "42": "Konya",
      "43": "Kütahya",
      "44": "Malatya",
      "45": "Manisa",
      "47": "Mardin",
      "33": "Mersin",
      "48": "Muğla",
      "49": "Muş",
      "50": "Nevşehir",
      "51": "Niğde",
      "52": "Ordu",
      "80": "Osmaniye",
      "53": "Rize",
      "54": "Sakarya",
      "55": "Samsun",
      "56": "Siirt",
      "57": "Sinop",
      "58": "Sivas",
      "63": "Şanlıurfa",
      "73": "Şırnak",
      "59": "Tekirdağ",
      "60": "Tokat",
      "61": "Trabzon",
      "62": "Tunceli",
      "64": "Uşak",
      "65": "Van",
      "77": "Yalova",
      "66": "Yozgat",
      "67": "Zonguldak"
    },
    "callingCodes": ["90"],
    "ISO2digit": "TR",
    "ISO3digit": "TUR",
    "allowed": true
  },
  "TM": {
    "name": "Turkmenistan",
    "provinces": {
      "A": "Ahal",
      "S": "Aşgabat",
      "B": "Balkan",
      "D": "Daşoguz",
      "L": "Lebap",
      "M": "Mary"
    },
    "callingCodes": ["993"],
    "ISO2digit": "TM",
    "ISO3digit": "TKM",
    "allowed": true
  },
  "TC": {
    "name": "Turks and Caicos Islands",
    "provinces": ["Turks and Caicos Islands"],
    "callingCodes": ["1649"],
    "ISO2digit": "TC",
    "ISO3digit": "TCA",
    "allowed": true
  },
  "TV": {
    "name": "Tuvalu",
    "provinces": {
      "FUN": "Funafuti",
      "NMG": "Nanumanga",
      "NMA": "Nanumea",
      "NIT": "Niutao",
      "NUI": "Nui",
      "NKF": "Nukufetau",
      "NKL": "Nukulaelae",
      "VAI": "Vaitupu"
    },
    "callingCodes": ["688"],
    "ISO2digit": "TV",
    "ISO3digit": "TUV",
    "allowed": true
  },
  "UG": {
    "name": "Uganda",
    "provinces": {
      "C": "Central",
      "E": "Eastern",
      "N": "Northern",
      "W": "Western"
    },
    "callingCodes": ["256"],
    "ISO2digit": "UG",
    "ISO3digit": "UGA",
    "allowed": true
  },
  "UA": {
    "name": "Ukraine",
    "provinces": {
      "43": "Avtonomna Respublika Krym",
      "71": "Cherkaska",
      "74": "Chernihivska",
      "77": "Chernivetska",
      "12": "Dnipropetrovska",
      "14": "Donetska",
      "26": "Ivano-Frankivska",
      "63": "Kharkivska",
      "65": "Khersonska",
      "68": "Khmelnytska",
      "35": "Kirovohradska",
      "30": "Kyiv",
      "32": "Kyivska",
      "09": "Luhanska",
      "46": "Lvivska",
      "48": "Mykolaivska",
      "51": "Odeska",
      "53": "Poltavska",
      "56": "Rivnenska",
      "40": "Sevastopol",
      "59": "Sumska",
      "61": "Ternopilska",
      "05": "Vinnytska",
      "07": "Volynska",
      "21": "Zakarpatska",
      "23": "Zaporizka",
      "18": "Zhytomyrska"
    },
    "callingCodes": ["380"],
    "ISO2digit": "UA",
    "ISO3digit": "UKR",
    "allowed": true
  },
  "AE": {
    "name": "United Arab Emirates",
    "provinces": {
      "AJ": "'Ajman",
      "AZ": "Abu Zaby",
      "FU": "Al Fujayrah",
      "SH": "Ash Shariqah",
      "DU": "Dubayy",
      "RK": "Ra's al Khaymah",
      "UQ": "Umm al Qaywayn"
    },
    "callingCodes": ["971"],
    "ISO2digit": "AE",
    "ISO3digit": "ARE",
    "allowed": true
  },
  "GB": {
    "name": "United Kingdom",
    "provinces": {
      "ABE": "Aberdeen City",
      "ABD": "Aberdeenshire",
      "ANS": "Angus",
      "ANN": "Antrim and Newtownabbey",
      "AND": "Ards and North Down",
      "AGB": "Argyll and Bute",
      "ABC": "Armagh, Banbridge and Craigavon",
      "BDG": "Barking and Dagenham",
      "BNE": "Barnet",
      "BNS": "Barnsley",
      "BAS": "Bath and North East Somerset",
      "BDF": "Bedford",
      "BFS": "Belfast",
      "BEX": "Bexley",
      "BIR": "Birmingham",
      "BBD": "Blackburn with Darwen",
      "BPL": "Blackpool",
      "BGW": "Blaenau Gwent",
      "BOL": "Bolton",
      "BMH": "Bournemouth",
      "BRC": "Bracknell Forest",
      "BRD": "Bradford",
      "BEN": "Brent",
      "BGE": "Bridgend",
      "BNH": "Brighton and Hove",
      "BST": "Bristol, City of",
      "BRY": "Bromley",
      "BKM": "Buckinghamshire",
      "BUR": "Bury",
      "CAY": "Caerphilly",
      "CLD": "Calderdale",
      "CAM": "Cambridgeshire",
      "CMD": "Camden",
      "CRF": "Cardiff",
      "CMN": "Carmarthenshire",
      "CCG": "Causeway Coast and Glens",
      "CBF": "Central Bedfordshire",
      "CGN": "Ceredigion",
      "CHE": "Cheshire East",
      "CHW": "Cheshire West and Chester",
      "CLK": "Clackmannanshire",
      "CWY": "Conwy",
      "CON": "Cornwall",
      "COV": "Coventry",
      "CRY": "Croydon",
      "CMA": "Cumbria",
      "DAL": "Darlington",
      "DEN": "Denbighshire",
      "DER": "Derby",
      "DBY": "Derbyshire",
      "DRS": "Derry and Strabane",
      "DEV": "Devon",
      "DNC": "Doncaster",
      "DOR": "Dorset",
      "DUD": "Dudley",
      "DGY": "Dumfries and Galloway",
      "DND": "Dundee City",
      "DUR": "Durham, County",
      "EAL": "Ealing",
      "EAY": "East Ayrshire",
      "EDU": "East Dunbartonshire",
      "ELN": "East Lothian",
      "ERW": "East Renfrewshire",
      "ERY": "East Riding of Yorkshire",
      "ESX": "East Sussex",
      "EDH": "Edinburgh, City of",
      "ELS": "Eilean Siar",
      "ENF": "Enfield",
      "ESS": "Essex",
      "FAL": "Falkirk",
      "FMO": "Fermanagh and Omagh",
      "FIF": "Fife",
      "FLN": "Flintshire",
      "GAT": "Gateshead",
      "GLG": "Glasgow City",
      "GLS": "Gloucestershire",
      "GRE": "Greenwich",
      "GWN": "Gwynedd",
      "HCK": "Hackney",
      "HAL": "Halton",
      "HMF": "Hammersmith and Fulham",
      "HAM": "Hampshire",
      "HRY": "Haringey",
      "HRW": "Harrow",
      "HPL": "Hartlepool",
      "HAV": "Havering",
      "HEF": "Herefordshire",
      "HRT": "Hertfordshire",
      "HLD": "Highland",
      "HIL": "Hillingdon",
      "HNS": "Hounslow",
      "IVC": "Inverclyde",
      "AGY": "Isle of Anglesey",
      "IOW": "Isle of Wight",
      "IOS": "Isles of Scilly",
      "ISL": "Islington",
      "KEC": "Kensington and Chelsea",
      "KEN": "Kent",
      "KHL": "Kingston upon Hull",
      "KTT": "Kingston upon Thames",
      "KIR": "Kirklees",
      "KWL": "Knowsley",
      "LBH": "Lambeth",
      "LAN": "Lancashire",
      "LDS": "Leeds",
      "LCE": "Leicester",
      "LEC": "Leicestershire",
      "LEW": "Lewisham",
      "LIN": "Lincolnshire",
      "LBC": "Lisburn and Castlereagh",
      "LIV": "Liverpool",
      "LND": "London, City of  city corporation",
      "LUT": "Luton",
      "MAN": "Manchester",
      "MDW": "Medway",
      "MTY": "Merthyr Tydfil",
      "MRT": "Merton",
      "MEA": "Mid and East Antrim",
      "MUL": "Mid Ulster",
      "MDB": "Middlesbrough",
      "MLN": "Midlothian",
      "MIK": "Milton Keynes",
      "MON": "Monmouthshire",
      "MRY": "Moray",
      "NTL": "Neath Port Talbot",
      "NET": "Newcastle upon Tyne",
      "NWM": "Newham",
      "NWP": "Newport",
      "NMD": "Newry, Mourne and Down",
      "NFK": "Norfolk",
      "NAY": "North Ayrshire",
      "NEL": "North East Lincolnshire",
      "NLK": "North Lanarkshire",
      "NLN": "North Lincolnshire",
      "NSM": "North Somerset",
      "NTY": "North Tyneside",
      "NYK": "North Yorkshire",
      "NTH": "Northamptonshire",
      "NBL": "Northumberland",
      "NGM": "Nottingham",
      "NTT": "Nottinghamshire",
      "OLD": "Oldham",
      "ORK": "Orkney Islands",
      "OXF": "Oxfordshire",
      "PEM": "Pembrokeshire",
      "PKN": "Perth and Kinross",
      "PTE": "Peterborough",
      "PLY": "Plymouth",
      "POL": "Poole",
      "POR": "Portsmouth",
      "POW": "Powys",
      "RDG": "Reading",
      "RDB": "Redbridge",
      "RCC": "Redcar and Cleveland",
      "RFW": "Renfrewshire",
      "RCT": "Rhondda, Cynon, Taff",
      "RIC": "Richmond upon Thames",
      "RCH": "Rochdale",
      "ROT": "Rotherham",
      "RUT": "Rutland",
      "SHN": "St. Helens",
      "SLF": "Salford",
      "SAW": "Sandwell",
      "SCB": "Scottish Borders, The",
      "SFT": "Sefton",
      "SHF": "Sheffield",
      "ZET": "Shetland Islands",
      "SHR": "Shropshire",
      "SLG": "Slough",
      "SOL": "Solihull",
      "SOM": "Somerset",
      "SAY": "South Ayrshire",
      "SGC": "South Gloucestershire",
      "SLK": "South Lanarkshire",
      "STY": "South Tyneside",
      "STH": "Southampton",
      "SOS": "Southend-on-Sea",
      "SWK": "Southwark",
      "STS": "Staffordshire",
      "STG": "Stirling",
      "SKP": "Stockport",
      "STT": "Stockton-on-Tees",
      "STE": "Stoke-on-Trent",
      "SFK": "Suffolk",
      "SND": "Sunderland",
      "SRY": "Surrey",
      "STN": "Sutton",
      "SWA": "Swansea",
      "SWD": "Swindon",
      "TAM": "Tameside",
      "TFW": "Telford and Wrekin",
      "THR": "Thurrock",
      "TOB": "Torbay",
      "TOF": "Torfaen",
      "TWH": "Tower Hamlets",
      "TRF": "Trafford",
      "VGL": "Vale of Glamorgan, The",
      "WKF": "Wakefield",
      "WLL": "Walsall",
      "WFT": "Waltham Forest",
      "WND": "Wandsworth",
      "WRT": "Warrington",
      "WAR": "Warwickshire",
      "WBK": "West Berkshire",
      "WDU": "West Dunbartonshire",
      "WLN": "West Lothian",
      "WSX": "West Sussex",
      "WSM": "Westminster",
      "WGN": "Wigan",
      "WIL": "Wiltshire",
      "WNM": "Windsor and Maidenhead",
      "WRL": "Wirral",
      "WOK": "Wokingham",
      "WLV": "Wolverhampton",
      "WOR": "Worcestershire",
      "WRX": "Wrexham",
      "YOR": "York"
    },
    "callingCodes": ["44"],
    "ISO2digit": "GB",
    "ISO3digit": "GBR",
    "allowed": false
  },
  "US": {
    "name": "United States",
    "provinces": {
      "AL": "Alabama",
      "AK": "Alaska",
      "AZ": "Arizona",
      "AR": "Arkansas",
      "CA": "California",
      "CO": "Colorado",
      "CT": "Connecticut",
      "DE": "Delaware",
      "DC": "District of Columbia",
      "FL": "Florida",
      "GA": "Georgia",
      "HI": "Hawaii",
      "ID": "Idaho",
      "IL": "Illinois",
      "IN": "Indiana",
      "IA": "Iowa",
      "KS": "Kansas",
      "KY": "Kentucky",
      "LA": "Louisiana",
      "ME": "Maine",
      "MD": "Maryland",
      "MA": "Massachusetts",
      "MI": "Michigan",
      "MN": "Minnesota",
      "MS": "Mississippi",
      "MO": "Missouri",
      "MT": "Montana",
      "NE": "Nebraska",
      "NV": "Nevada",
      "NH": "New Hampshire",
      "NJ": "New Jersey",
      "NM": "New Mexico",
      "NY": "New York",
      "NC": "North Carolina",
      "ND": "North Dakota",
      "OH": "Ohio",
      "OK": "Oklahoma",
      "OR": "Oregon",
      "PA": "Pennsylvania",
      "RI": "Rhode Island",
      "SC": "South Carolina",
      "SD": "South Dakota",
      "TN": "Tennessee",
      "TX": "Texas",
      "UT": "Utah",
      "VT": "Vermont",
      "VA": "Virginia",
      "WA": "Washington",
      "WV": "West Virginia",
      "WI": "Wisconsin",
      "WY": "Wyoming"
    },
    "callingCodes": ["1"],
    "ISO2digit": "US",
    "ISO3digit": "USA",
    "allowed": true
  },
  "UM": {
    "name": "United States Minor Outlying Islands",
    "provinces": [
      "Baker Island",
      "Howland Island",
      "Jarvis Island",
      "Johnston Atoll",
      "Kingman Reef",
      "Midway Islands",
      "Navassa Island",
      "Palmyra Atoll",
      "Wake Island"
    ],
    "callingCodes": ["1"],
    "ISO2digit": "UM",
    "ISO3digit": "UMI",
    "allowed": true
  },
  "UY": {
    "name": "Uruguay",
    "provinces": {
      "AR": "Artigas",
      "CA": "Canelones",
      "CL": "Cerro Largo",
      "CO": "Colonia",
      "DU": "Durazno",
      "FS": "Flores",
      "FD": "Florida",
      "LA": "Lavalleja",
      "MA": "Maldonado",
      "MO": "Montevideo",
      "PA": "Paysandú",
      "RN": "Río Negro",
      "RV": "Rivera",
      "RO": "Rocha",
      "SA": "Salto",
      "SJ": "San José",
      "SO": "Soriano",
      "TA": "Tacuarembó",
      "TT": "Treinta y Tres"
    },
    "callingCodes": ["598"],
    "ISO2digit": "UY",
    "ISO3digit": "URY",
    "allowed": true
  },
  "UZ": {
    "name": "Uzbekistan",
    "provinces": {
      "AN": "Andijon",
      "BU": "Buxoro",
      "FA": "Farg‘ona",
      "JI": "Jizzax",
      "NG": "Namangan",
      "NW": "Navoiy",
      "QA": "Qashqadaryo",
      "QR": "Qoraqalpog‘iston Respublikasi",
      "SA": "Samarqand",
      "SI": "Sirdaryo",
      "SU": "Surxondaryo",
      "TO": "Toshkent",
      "XO": "Xorazm"
    },
    "callingCodes": ["998"],
    "ISO2digit": "UZ",
    "ISO3digit": "UZB",
    "allowed": true
  },
  "VU": {
    "name": "Vanuatu",
    "provinces": {
      "MAP": "Malampa",
      "PAM": "Pénama",
      "SAM": "Sanma",
      "SEE": "Shéfa",
      "TAE": "Taféa",
      "TOB": "Torba"
    },
    "callingCodes": ["678"],
    "ISO2digit": "VU",
    "ISO3digit": "VUT",
    "allowed": true
  },
  "VA": {
    "name": "Vatican City",
    "provinces": ["Vatican City"],
    "callingCodes": ["379"],
    "ISO2digit": "VA",
    "ISO3digit": "VAT",
    "allowed": true
  },
  "VE": {
    "name": "Venezuela",
    "provinces": {
      "Z": "Amazonas",
      "B": "Anzoátegui",
      "C": "Apure",
      "D": "Aragua",
      "E": "Barinas",
      "F": "Bolívar",
      "G": "Carabobo",
      "H": "Cojedes",
      "Y": "Delta Amacuro",
      "W": "Dependencias Federales",
      "A": "Distrito Federal",
      "I": "Falcón",
      "J": "Guárico",
      "K": "Lara",
      "L": "Mérida",
      "M": "Miranda",
      "N": "Monagas",
      "O": "Nueva Esparta",
      "P": "Portuguesa",
      "R": "Sucre",
      "S": "Táchira",
      "T": "Trujillo",
      "X": "Vargas",
      "U": "Yaracuy",
      "V": "Zulia"
    },
    "callingCodes": ["58"],
    "ISO2digit": "VE",
    "ISO3digit": "VEN",
    "allowed": true
  },
  "VN": {
    "name": "Vietnam",
    "provinces": {
      "44": "An Giang",
      "43": "Bà Rịa–Vũng Tàu",
      "55": "Bạc Liêu",
      "54": "Bắc Giang",
      "53": "Bắc Kạn",
      "56": "Bắc Ninh",
      "50": "Bến Tre",
      "57": "Bình Dương",
      "31": "Bình Định",
      "58": "Bình Phước",
      "40": "Bình Thuận",
      "59": "Cà Mau",
      "04": "Cao Bằng",
      "CT": "Cần Thơ",
      "DN": "Đà Nẵng",
      "33": "Đắk Lắk",
      "72": "Đắk Nông",
      "71": "Điện Biên",
      "39": "Đồng Nai",
      "45": "Đồng Tháp",
      "30": "Gia Lai",
      "03": "Hà Giang",
      "63": "Hà Nam",
      "HN": "Hà Nội",
      "23": "Hà Tĩnh",
      "61": "Hải Dương",
      "HP": "Hải Phòng",
      "73": "Hậu Giang",
      "14": "Hòa Bình",
      "66": "Hưng Yên",
      "SG": "Hồ Chí Minh",
      "34": "Khánh Hòa",
      "47": "Kiên Giang",
      "28": "Kon Tum",
      "01": "Lai Châu",
      "09": "Lạng Sơn",
      "02": "Lào Cai",
      "35": "Lâm Đồng",
      "41": "Long An",
      "67": "Nam Định",
      "22": "Nghệ An",
      "18": "Ninh Bình",
      "36": "Ninh Thuận",
      "68": "Phú Thọ",
      "32": "Phú Yên",
      "24": "Quảng Bình",
      "27": "Quảng Nam",
      "29": "Quảng Ngãi",
      "13": "Quảng Ninh",
      "25": "Quảng Trị",
      "52": "Sóc Trăng",
      "05": "Sơn La",
      "37": "Tây Ninh",
      "20": "Thái Bình",
      "69": "Thái Nguyên",
      "21": "Thanh Hóa",
      "26": "Thừa Thiên–Huế",
      "46": "Tiền Giang",
      "51": "Trà Vinh",
      "07": "Tuyên Quang",
      "49": "Vĩnh Long",
      "70": "Vĩnh Phúc",
      "06": "Yên Bái"
    },
    "callingCodes": ["84"],
    "ISO2digit": "VN",
    "ISO3digit": "VNM",
    "allowed": true
  },
  "VG": {
    "name": "Virgin Islands, British",
    "provinces": ["Virgin Islands, British"],
    "callingCodes": ["1284"],
    "ISO2digit": "VG",
    "ISO3digit": "VGB",
    "allowed": true
  },
  "VI": {
    "name": "Virgin Islands, U.S.",
    "provinces": [
      "Saint Croix",
      "Saint Thomas",
      "Saint John"
    ],
    "callingCodes": ["1"],
    "ISO2digit": "VI",
    "ISO3digit": "VIR",
    "allowed": true
  },
  "WF": {
    "name": "Wallis and Futuna",
    "provinces": {
      "AL": "Alo",
      "SG": "Sigave",
      "UV": "Uvea"
    },
    "callingCodes": ["681"],
    "ISO2digit": "WF",
    "ISO3digit": "WLF",
    "allowed": true
  },
  "EH": {
    "name": "Western Sahara",
    "provinces": {
      "ESM": "Es Smara",
      "BOD": "Boujdour",
      "LAA": "Laâyoune",
      "AOU": "Aousserd",
      "OUD": "Oued ed Dahab"
    },
    "callingCodes": ["212"],
    "ISO2digit": "EH",
    "ISO3digit": "ESH",
    "allowed": true
  },
  "YE": {
    "name": "Yemen",
    "provinces": {
      "AB": "Abyān",
      "AD": "‘Adan",
      "DA": "Aḑ Ḑāli‘",
      "BA": "Al Bayḑā’",
      "HU": "Al Ḩudaydah",
      "JA": "Al Jawf",
      "MR": "Al Mahrah",
      "MW": "Al Maḩwīt",
      "AM": "‘Amrān",
      "SU": "Arkhabīl Suquţrá",
      "DH": "Dhamār",
      "HD": "Ḩaḑramawt",
      "HJ": "Ḩajjah",
      "IB": "Ibb",
      "LA": "Laḩij",
      "MA": "Ma’rib",
      "RA": "Raymah",
      "SD": "Şāʻdah",
      "SA": "Amānat al ‘Āşimah",
      "SN": "Şanʻā’",
      "SH": "Shabwah",
      "TA": "Tā‘izz"
    },
    "callingCodes": ["967"],
    "ISO2digit": "YE",
    "ISO3digit": "YEM",
    "allowed": true
  },
  "ZM": {
    "name": "Zambia",
    "provinces": {
      "02": "Central",
      "08": "Copperbelt",
      "03": "Eastern",
      "04": "Luapula",
      "09": "Lusaka",
      "10": "Muchinga",
      "05": "Northern",
      "06": "North-Western",
      "07": "Southern",
      "01": "Western"
    },
    "callingCodes": ["260"],
    "ISO2digit": "ZM",
    "ISO3digit": "ZMB",
    "allowed": true
  },
  "ZW": {
    "name": "Zimbabwe",
    "provinces": {
      "BU": "Bulawayo",
      "HA": "Harare",
      "MA": "Manicaland",
      "MC": "Mashonaland Central",
      "ME": "Mashonaland East",
      "MW": "Mashonaland West",
      "MV": "Masvingo",
      "MN": "Matabeleland North",
      "MS": "Matabeleland South",
      "MI": "Midlands"
    },
    "callingCodes": ["263"],
    "ISO2digit": "ZW",
    "ISO3digit": "ZWE",
    "allowed": false
  }
}
